/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const ze = "172", Ps = 0, Ls = 1, Os = 2, Ns = 0, Vs = 1, Ws = 3, Us = 0, qs = 1, js = 2, Gs = 0, Xs = 1, Hs = 2, Ys = 3, Zs = 4, Js = 5, $s = 100, Qs = 101, Ks = 102, tn = 103, en = 104, sn = 200, nn = 201, rn = 202, an = 203, hn = 204, on = 205, ln = 206, cn = 207, un = 208, pn = 209, dn = 210, mn = 0, fn = 1, yn = 2, xn = 3, gn = 4, Mn = 5, wn = 6, bn = 7, Sn = 0, _n = 1, zn = 2, An = 0, Fn = 1, Tn = 2, Cn = 3, Bn = 4, vn = 6, Rn = 7, En = 300, kn = 301, In = 302, Dn = 303, Pn = 304, Ln = 306, On = 1e3, Nn = 1001, Vn = 1002, Wn = 1003, Un = 1004, qn = 1005, jn = 1006, Gn = 1007, Xn = 1008, Hn = 1008, Yn = 1009, Zn = 1010, Jn = 1011, $n = 1012, Qn = 1013, Kn = 1014, tr = 1015, ir = 1016, er = 1017, sr = 1018, nr = 1020, rr = 35902, ar = 1021, hr = 1022, or = 1023, lr = 1024, cr = 1025, ur = 1026, pr = 1027, dr = 1028, mr = 1029, fr = 1030, yr = 1031, xr = 1032, gr = 1033, Mr = 33776, wr = 33777, br = 33778, Sr = 33779, _r = 35840, zr = 35841, Ar = 35842, Fr = 35843, Tr = 36196, Cr = 37492, Br = 37496, vr = 37808, Rr = 37809, Er = 37810, kr = 37811, Ir = 37812, Dr = 37813, Pr = 37814, Lr = 37815, Or = 37816, Nr = 37817, Vr = 37818, Wr = 37819, Ur = 37820, qr = 37821, jr = 36492, Gr = 36283, Xr = 36284, Hr = 36285, Yr = 36286, Zr = 0, Jr = 1, Ae = "", et = "srgb", ie = "srgb-linear", ee = "linear", Fi = "srgb", $r = 0, Qr = 7680, Kr = 7681, ta = 7682, ia = 7683, ea = 34055, sa = 34056, na = 5386, ra = 512, aa = 513, ha = 514, oa = 515, la = 516, ca = 517, ua = 518, pa = 519, da = 512, ma = 513, fa = 514, ya = 515, xa = 516, ga = 517, Ma = 518, wa = 519, ba = 35044, Sa = 35048, _a = 2e3, za = 2001;
class si {
  addEventListener(t, i) {
    this._listeners === void 0 && (this._listeners = {});
    const e = this._listeners;
    e[t] === void 0 && (e[t] = []), e[t].indexOf(i) === -1 && e[t].push(i);
  }
  hasEventListener(t, i) {
    if (this._listeners === void 0) return !1;
    const e = this._listeners;
    return e[t] !== void 0 && e[t].indexOf(i) !== -1;
  }
  removeEventListener(t, i) {
    if (this._listeners === void 0) return;
    const s = this._listeners[t];
    if (s !== void 0) {
      const n = s.indexOf(i);
      n !== -1 && s.splice(n, 1);
    }
  }
  dispatchEvent(t) {
    if (this._listeners === void 0) return;
    const e = this._listeners[t.type];
    if (e !== void 0) {
      t.target = this;
      const s = e.slice(0);
      for (let n = 0, r = s.length; n < r; n++)
        s[n].call(this, t);
      t.target = null;
    }
  }
}
const V = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let se = 1234567;
const ti = Math.PI / 180, ei = 180 / Math.PI;
function mt() {
  const p = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, i = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0;
  return (V[p & 255] + V[p >> 8 & 255] + V[p >> 16 & 255] + V[p >> 24 & 255] + "-" + V[t & 255] + V[t >> 8 & 255] + "-" + V[t >> 16 & 15 | 64] + V[t >> 24 & 255] + "-" + V[i & 63 | 128] + V[i >> 8 & 255] + "-" + V[i >> 16 & 255] + V[i >> 24 & 255] + V[e & 255] + V[e >> 8 & 255] + V[e >> 16 & 255] + V[e >> 24 & 255]).toLowerCase();
}
function T(p, t, i) {
  return Math.max(t, Math.min(i, p));
}
function Ji(p, t) {
  return (p % t + t) % t;
}
function ke(p, t, i, e, s) {
  return e + (p - t) * (s - e) / (i - t);
}
function Ie(p, t, i) {
  return p !== t ? (i - p) / (t - p) : 0;
}
function ii(p, t, i) {
  return (1 - i) * p + i * t;
}
function De(p, t, i, e) {
  return ii(p, t, 1 - Math.exp(-i * e));
}
function Pe(p, t = 1) {
  return t - Math.abs(Ji(p, t * 2) - t);
}
function Le(p, t, i) {
  return p <= t ? 0 : p >= i ? 1 : (p = (p - t) / (i - t), p * p * (3 - 2 * p));
}
function Oe(p, t, i) {
  return p <= t ? 0 : p >= i ? 1 : (p = (p - t) / (i - t), p * p * p * (p * (p * 6 - 15) + 10));
}
function Ne(p, t) {
  return p + Math.floor(Math.random() * (t - p + 1));
}
function Ve(p, t) {
  return p + Math.random() * (t - p);
}
function We(p) {
  return p * (0.5 - Math.random());
}
function Ue(p) {
  p !== void 0 && (se = p);
  let t = se += 1831565813;
  return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function qe(p) {
  return p * ti;
}
function je(p) {
  return p * ei;
}
function Ge(p) {
  return (p & p - 1) === 0 && p !== 0;
}
function Xe(p) {
  return Math.pow(2, Math.ceil(Math.log(p) / Math.LN2));
}
function He(p) {
  return Math.pow(2, Math.floor(Math.log(p) / Math.LN2));
}
function Ye(p, t, i, e, s) {
  const n = Math.cos, r = Math.sin, h = n(i / 2), a = r(i / 2), o = n((t + e) / 2), l = r((t + e) / 2), c = n((t - e) / 2), u = r((t - e) / 2), d = n((e - t) / 2), m = r((e - t) / 2);
  switch (s) {
    case "XYX":
      p.set(h * l, a * c, a * u, h * o);
      break;
    case "YZY":
      p.set(a * u, h * l, a * c, h * o);
      break;
    case "ZXZ":
      p.set(a * c, a * u, h * l, h * o);
      break;
    case "XZX":
      p.set(h * l, a * m, a * d, h * o);
      break;
    case "YXY":
      p.set(a * d, h * l, a * m, h * o);
      break;
    case "ZYZ":
      p.set(a * m, a * d, h * l, h * o);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + s);
  }
}
function q(p, t) {
  switch (t.constructor) {
    case Float32Array:
      return p;
    case Uint32Array:
      return p / 4294967295;
    case Uint16Array:
      return p / 65535;
    case Uint8Array:
      return p / 255;
    case Int32Array:
      return Math.max(p / 2147483647, -1);
    case Int16Array:
      return Math.max(p / 32767, -1);
    case Int8Array:
      return Math.max(p / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function z(p, t) {
  switch (t.constructor) {
    case Float32Array:
      return p;
    case Uint32Array:
      return Math.round(p * 4294967295);
    case Uint16Array:
      return Math.round(p * 65535);
    case Uint8Array:
      return Math.round(p * 255);
    case Int32Array:
      return Math.round(p * 2147483647);
    case Int16Array:
      return Math.round(p * 32767);
    case Int8Array:
      return Math.round(p * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const Aa = {
  DEG2RAD: ti,
  RAD2DEG: ei,
  generateUUID: mt,
  clamp: T,
  euclideanModulo: Ji,
  mapLinear: ke,
  inverseLerp: Ie,
  lerp: ii,
  damp: De,
  pingpong: Pe,
  smoothstep: Le,
  smootherstep: Oe,
  randInt: Ne,
  randFloat: Ve,
  randFloatSpread: We,
  seededRandom: Ue,
  degToRad: qe,
  radToDeg: je,
  isPowerOfTwo: Ge,
  ceilPowerOfTwo: Xe,
  floorPowerOfTwo: He,
  setQuaternionFromProperEuler: Ye,
  normalize: z,
  denormalize: q
};
class C {
  constructor(t = 0, i = 0) {
    C.prototype.isVector2 = !0, this.x = t, this.y = i;
  }
  get width() {
    return this.x;
  }
  set width(t) {
    this.x = t;
  }
  get height() {
    return this.y;
  }
  set height(t) {
    this.y = t;
  }
  set(t, i) {
    return this.x = t, this.y = i, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setComponent(t, i) {
    switch (t) {
      case 0:
        this.x = i;
        break;
      case 1:
        this.y = i;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this;
  }
  addVectors(t, i) {
    return this.x = t.x + i.x, this.y = t.y + i.y, this;
  }
  addScaledVector(t, i) {
    return this.x += t.x * i, this.y += t.y * i, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this;
  }
  subVectors(t, i) {
    return this.x = t.x - i.x, this.y = t.y - i.y, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this;
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  applyMatrix3(t) {
    const i = this.x, e = this.y, s = t.elements;
    return this.x = s[0] * i + s[3] * e + s[6], this.y = s[1] * i + s[4] * e + s[7], this;
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
  }
  clamp(t, i) {
    return this.x = T(this.x, t.x, i.x), this.y = T(this.y, t.y, i.y), this;
  }
  clampScalar(t, i) {
    return this.x = T(this.x, t, i), this.y = T(this.y, t, i), this;
  }
  clampLength(t, i) {
    const e = this.length();
    return this.divideScalar(e || 1).multiplyScalar(T(e, t, i));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y;
  }
  cross(t) {
    return this.x * t.y - this.y * t.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  angleTo(t) {
    const i = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (i === 0) return Math.PI / 2;
    const e = this.dot(t) / i;
    return Math.acos(T(e, -1, 1));
  }
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  distanceToSquared(t) {
    const i = this.x - t.x, e = this.y - t.y;
    return i * i + e * e;
  }
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, i) {
    return this.x += (t.x - this.x) * i, this.y += (t.y - this.y) * i, this;
  }
  lerpVectors(t, i, e) {
    return this.x = t.x + (i.x - t.x) * e, this.y = t.y + (i.y - t.y) * e, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y;
  }
  fromArray(t, i = 0) {
    return this.x = t[i], this.y = t[i + 1], this;
  }
  toArray(t = [], i = 0) {
    return t[i] = this.x, t[i + 1] = this.y, t;
  }
  fromBufferAttribute(t, i) {
    return this.x = t.getX(i), this.y = t.getY(i), this;
  }
  rotateAround(t, i) {
    const e = Math.cos(i), s = Math.sin(i), n = this.x - t.x, r = this.y - t.y;
    return this.x = n * e - r * s + t.x, this.y = n * s + r * e + t.y, this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class xt {
  constructor(t, i, e, s, n, r, h, a, o) {
    xt.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], t !== void 0 && this.set(t, i, e, s, n, r, h, a, o);
  }
  set(t, i, e, s, n, r, h, a, o) {
    const l = this.elements;
    return l[0] = t, l[1] = s, l[2] = h, l[3] = i, l[4] = n, l[5] = a, l[6] = e, l[7] = r, l[8] = o, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  copy(t) {
    const i = this.elements, e = t.elements;
    return i[0] = e[0], i[1] = e[1], i[2] = e[2], i[3] = e[3], i[4] = e[4], i[5] = e[5], i[6] = e[6], i[7] = e[7], i[8] = e[8], this;
  }
  extractBasis(t, i, e) {
    return t.setFromMatrix3Column(this, 0), i.setFromMatrix3Column(this, 1), e.setFromMatrix3Column(this, 2), this;
  }
  setFromMatrix4(t) {
    const i = t.elements;
    return this.set(
      i[0],
      i[4],
      i[8],
      i[1],
      i[5],
      i[9],
      i[2],
      i[6],
      i[10]
    ), this;
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyMatrices(t, i) {
    const e = t.elements, s = i.elements, n = this.elements, r = e[0], h = e[3], a = e[6], o = e[1], l = e[4], c = e[7], u = e[2], d = e[5], m = e[8], y = s[0], x = s[3], g = s[6], w = s[1], b = s[4], M = s[7], S = s[2], F = s[5], _ = s[8];
    return n[0] = r * y + h * w + a * S, n[3] = r * x + h * b + a * F, n[6] = r * g + h * M + a * _, n[1] = o * y + l * w + c * S, n[4] = o * x + l * b + c * F, n[7] = o * g + l * M + c * _, n[2] = u * y + d * w + m * S, n[5] = u * x + d * b + m * F, n[8] = u * g + d * M + m * _, this;
  }
  multiplyScalar(t) {
    const i = this.elements;
    return i[0] *= t, i[3] *= t, i[6] *= t, i[1] *= t, i[4] *= t, i[7] *= t, i[2] *= t, i[5] *= t, i[8] *= t, this;
  }
  determinant() {
    const t = this.elements, i = t[0], e = t[1], s = t[2], n = t[3], r = t[4], h = t[5], a = t[6], o = t[7], l = t[8];
    return i * r * l - i * h * o - e * n * l + e * h * a + s * n * o - s * r * a;
  }
  invert() {
    const t = this.elements, i = t[0], e = t[1], s = t[2], n = t[3], r = t[4], h = t[5], a = t[6], o = t[7], l = t[8], c = l * r - h * o, u = h * a - l * n, d = o * n - r * a, m = i * c + e * u + s * d;
    if (m === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const y = 1 / m;
    return t[0] = c * y, t[1] = (s * o - l * e) * y, t[2] = (h * e - s * r) * y, t[3] = u * y, t[4] = (l * i - s * a) * y, t[5] = (s * n - h * i) * y, t[6] = d * y, t[7] = (e * a - o * i) * y, t[8] = (r * i - e * n) * y, this;
  }
  transpose() {
    let t;
    const i = this.elements;
    return t = i[1], i[1] = i[3], i[3] = t, t = i[2], i[2] = i[6], i[6] = t, t = i[5], i[5] = i[7], i[7] = t, this;
  }
  getNormalMatrix(t) {
    return this.setFromMatrix4(t).invert().transpose();
  }
  transposeIntoArray(t) {
    const i = this.elements;
    return t[0] = i[0], t[1] = i[3], t[2] = i[6], t[3] = i[1], t[4] = i[4], t[5] = i[7], t[6] = i[2], t[7] = i[5], t[8] = i[8], this;
  }
  setUvTransform(t, i, e, s, n, r, h) {
    const a = Math.cos(n), o = Math.sin(n);
    return this.set(
      e * a,
      e * o,
      -e * (a * r + o * h) + r + t,
      -s * o,
      s * a,
      -s * (-o * r + a * h) + h + i,
      0,
      0,
      1
    ), this;
  }
  //
  scale(t, i) {
    return this.premultiply(Ti.makeScale(t, i)), this;
  }
  rotate(t) {
    return this.premultiply(Ti.makeRotation(-t)), this;
  }
  translate(t, i) {
    return this.premultiply(Ti.makeTranslation(t, i)), this;
  }
  // for 2D Transforms
  makeTranslation(t, i) {
    return t.isVector2 ? this.set(
      1,
      0,
      t.x,
      0,
      1,
      t.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      t,
      0,
      1,
      i,
      0,
      0,
      1
    ), this;
  }
  makeRotation(t) {
    const i = Math.cos(t), e = Math.sin(t);
    return this.set(
      i,
      -e,
      0,
      e,
      i,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(t, i) {
    return this.set(
      t,
      0,
      0,
      0,
      i,
      0,
      0,
      0,
      1
    ), this;
  }
  //
  equals(t) {
    const i = this.elements, e = t.elements;
    for (let s = 0; s < 9; s++)
      if (i[s] !== e[s]) return !1;
    return !0;
  }
  fromArray(t, i = 0) {
    for (let e = 0; e < 9; e++)
      this.elements[e] = t[e + i];
    return this;
  }
  toArray(t = [], i = 0) {
    const e = this.elements;
    return t[i] = e[0], t[i + 1] = e[1], t[i + 2] = e[2], t[i + 3] = e[3], t[i + 4] = e[4], t[i + 5] = e[5], t[i + 6] = e[6], t[i + 7] = e[7], t[i + 8] = e[8], t;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const Ti = /* @__PURE__ */ new xt();
function Ze(p) {
  for (let t = p.length - 1; t >= 0; --t)
    if (p[t] >= 65535) return !0;
  return !1;
}
function Zi(p) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", p);
}
function Fa() {
  const p = Zi("canvas");
  return p.style.display = "block", p;
}
const ne = {};
function Ta(p) {
  p in ne || (ne[p] = !0, console.warn(p));
}
const re = /* @__PURE__ */ new xt().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
), ae = /* @__PURE__ */ new xt().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function Je() {
  const p = {
    enabled: !0,
    workingColorSpace: ie,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(s, n, r) {
      return this.enabled === !1 || n === r || !n || !r || (this.spaces[n].transfer === Fi && (s.r = ft(s.r), s.g = ft(s.g), s.b = ft(s.b)), this.spaces[n].primaries !== this.spaces[r].primaries && (s.applyMatrix3(this.spaces[n].toXYZ), s.applyMatrix3(this.spaces[r].fromXYZ)), this.spaces[r].transfer === Fi && (s.r = Yt(s.r), s.g = Yt(s.g), s.b = Yt(s.b))), s;
    },
    fromWorkingColorSpace: function(s, n) {
      return this.convert(s, this.workingColorSpace, n);
    },
    toWorkingColorSpace: function(s, n) {
      return this.convert(s, n, this.workingColorSpace);
    },
    getPrimaries: function(s) {
      return this.spaces[s].primaries;
    },
    getTransfer: function(s) {
      return s === Ae ? ee : this.spaces[s].transfer;
    },
    getLuminanceCoefficients: function(s, n = this.workingColorSpace) {
      return s.fromArray(this.spaces[n].luminanceCoefficients);
    },
    define: function(s) {
      Object.assign(this.spaces, s);
    },
    // Internal APIs
    _getMatrix: function(s, n, r) {
      return s.copy(this.spaces[n].toXYZ).multiply(this.spaces[r].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(s) {
      return this.spaces[s].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(s = this.workingColorSpace) {
      return this.spaces[s].workingColorSpaceConfig.unpackColorSpace;
    }
  }, t = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06], i = [0.2126, 0.7152, 0.0722], e = [0.3127, 0.329];
  return p.define({
    [ie]: {
      primaries: t,
      whitePoint: e,
      transfer: ee,
      toXYZ: re,
      fromXYZ: ae,
      luminanceCoefficients: i,
      workingColorSpaceConfig: { unpackColorSpace: et },
      outputColorSpaceConfig: { drawingBufferColorSpace: et }
    },
    [et]: {
      primaries: t,
      whitePoint: e,
      transfer: Fi,
      toXYZ: re,
      fromXYZ: ae,
      luminanceCoefficients: i,
      outputColorSpaceConfig: { drawingBufferColorSpace: et }
    }
  }), p;
}
const Q = /* @__PURE__ */ Je();
function ft(p) {
  return p < 0.04045 ? p * 0.0773993808 : Math.pow(p * 0.9478672986 + 0.0521327014, 2.4);
}
function Yt(p) {
  return p < 31308e-7 ? p * 12.92 : 1.055 * Math.pow(p, 0.41666) - 0.055;
}
let Dt;
class $e {
  static getDataURL(t) {
    if (/^data:/i.test(t.src) || typeof HTMLCanvasElement > "u")
      return t.src;
    let i;
    if (t instanceof HTMLCanvasElement)
      i = t;
    else {
      Dt === void 0 && (Dt = Zi("canvas")), Dt.width = t.width, Dt.height = t.height;
      const e = Dt.getContext("2d");
      t instanceof ImageData ? e.putImageData(t, 0, 0) : e.drawImage(t, 0, 0, t.width, t.height), i = Dt;
    }
    return i.width > 2048 || i.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t), i.toDataURL("image/jpeg", 0.6)) : i.toDataURL("image/png");
  }
  static sRGBToLinear(t) {
    if (typeof HTMLImageElement < "u" && t instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && t instanceof ImageBitmap) {
      const i = Zi("canvas");
      i.width = t.width, i.height = t.height;
      const e = i.getContext("2d");
      e.drawImage(t, 0, 0, t.width, t.height);
      const s = e.getImageData(0, 0, t.width, t.height), n = s.data;
      for (let r = 0; r < n.length; r++)
        n[r] = ft(n[r] / 255) * 255;
      return e.putImageData(s, 0, 0), i;
    } else if (t.data) {
      const i = t.data.slice(0);
      for (let e = 0; e < i.length; e++)
        i instanceof Uint8Array || i instanceof Uint8ClampedArray ? i[e] = Math.floor(ft(i[e] / 255) * 255) : i[e] = ft(i[e]);
      return {
        data: i,
        width: t.width,
        height: t.height
      };
    } else
      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
  }
}
let Qe = 0;
class Fe {
  constructor(t = null) {
    this.isSource = !0, Object.defineProperty(this, "id", { value: Qe++ }), this.uuid = mt(), this.data = t, this.dataReady = !0, this.version = 0;
  }
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  toJSON(t) {
    const i = t === void 0 || typeof t == "string";
    if (!i && t.images[this.uuid] !== void 0)
      return t.images[this.uuid];
    const e = {
      uuid: this.uuid,
      url: ""
    }, s = this.data;
    if (s !== null) {
      let n;
      if (Array.isArray(s)) {
        n = [];
        for (let r = 0, h = s.length; r < h; r++)
          s[r].isDataTexture ? n.push(Ci(s[r].image)) : n.push(Ci(s[r]));
      } else
        n = Ci(s);
      e.url = n;
    }
    return i || (t.images[this.uuid] = e), e;
  }
}
function Ci(p) {
  return typeof HTMLImageElement < "u" && p instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && p instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && p instanceof ImageBitmap ? $e.getDataURL(p) : p.data ? {
    data: Array.from(p.data),
    width: p.width,
    height: p.height,
    type: p.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
let Ke = 0;
class Z extends si {
  constructor(t = Z.DEFAULT_IMAGE, i = Z.DEFAULT_MAPPING, e = 1001, s = 1001, n = 1006, r = 1008, h = 1023, a = 1009, o = Z.DEFAULT_ANISOTROPY, l = Ae) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: Ke++ }), this.uuid = mt(), this.name = "", this.source = new Fe(t), this.mipmaps = [], this.mapping = i, this.channel = 0, this.wrapS = e, this.wrapT = s, this.magFilter = n, this.minFilter = r, this.anisotropy = o, this.format = h, this.internalFormat = null, this.type = a, this.offset = new C(0, 0), this.repeat = new C(1, 1), this.center = new C(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new xt(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = l, this.userData = {}, this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.pmremVersion = 0;
  }
  get image() {
    return this.source.data;
  }
  set image(t = null) {
    this.source.data = t;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.channel = t.channel, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.colorSpace = t.colorSpace, this.renderTarget = t.renderTarget, this.isRenderTargetTexture = t.isRenderTargetTexture, this.userData = JSON.parse(JSON.stringify(t.userData)), this.needsUpdate = !0, this;
  }
  toJSON(t) {
    const i = t === void 0 || typeof t == "string";
    if (!i && t.textures[this.uuid] !== void 0)
      return t.textures[this.uuid];
    const e = {
      metadata: {
        version: 4.6,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(t).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (e.userData = this.userData), i || (t.textures[this.uuid] = e), e;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(t) {
    if (this.mapping !== 300) return t;
    if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1)
      switch (this.wrapS) {
        case 1e3:
          t.x = t.x - Math.floor(t.x);
          break;
        case 1001:
          t.x = t.x < 0 ? 0 : 1;
          break;
        case 1002:
          Math.abs(Math.floor(t.x) % 2) === 1 ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
          break;
      }
    if (t.y < 0 || t.y > 1)
      switch (this.wrapT) {
        case 1e3:
          t.y = t.y - Math.floor(t.y);
          break;
        case 1001:
          t.y = t.y < 0 ? 0 : 1;
          break;
        case 1002:
          Math.abs(Math.floor(t.y) % 2) === 1 ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
          break;
      }
    return this.flipY && (t.y = 1 - t.y), t;
  }
  set needsUpdate(t) {
    t === !0 && (this.version++, this.source.needsUpdate = !0);
  }
  set needsPMREMUpdate(t) {
    t === !0 && this.pmremVersion++;
  }
}
Z.DEFAULT_IMAGE = null;
Z.DEFAULT_MAPPING = 300;
Z.DEFAULT_ANISOTROPY = 1;
class j {
  constructor(t = 0, i = 0, e = 0, s = 1) {
    j.prototype.isVector4 = !0, this.x = t, this.y = i, this.z = e, this.w = s;
  }
  get width() {
    return this.z;
  }
  set width(t) {
    this.z = t;
  }
  get height() {
    return this.w;
  }
  set height(t) {
    this.w = t;
  }
  set(t, i, e, s) {
    return this.x = t, this.y = i, this.z = e, this.w = s, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this.z = t, this.w = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setZ(t) {
    return this.z = t, this;
  }
  setW(t) {
    return this.w = t, this;
  }
  setComponent(t, i) {
    switch (t) {
      case 0:
        this.x = i;
        break;
      case 1:
        this.y = i;
        break;
      case 2:
        this.z = i;
        break;
      case 3:
        this.w = i;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this.w = t.w !== void 0 ? t.w : 1, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this.z += t, this.w += t, this;
  }
  addVectors(t, i) {
    return this.x = t.x + i.x, this.y = t.y + i.y, this.z = t.z + i.z, this.w = t.w + i.w, this;
  }
  addScaledVector(t, i) {
    return this.x += t.x * i, this.y += t.y * i, this.z += t.z * i, this.w += t.w * i, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
  }
  subVectors(t, i) {
    return this.x = t.x - i.x, this.y = t.y - i.y, this.z = t.z - i.z, this.w = t.w - i.w, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
  }
  applyMatrix4(t) {
    const i = this.x, e = this.y, s = this.z, n = this.w, r = t.elements;
    return this.x = r[0] * i + r[4] * e + r[8] * s + r[12] * n, this.y = r[1] * i + r[5] * e + r[9] * s + r[13] * n, this.z = r[2] * i + r[6] * e + r[10] * s + r[14] * n, this.w = r[3] * i + r[7] * e + r[11] * s + r[15] * n, this;
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this.z /= t.z, this.w /= t.w, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  setAxisAngleFromQuaternion(t) {
    this.w = 2 * Math.acos(t.w);
    const i = Math.sqrt(1 - t.w * t.w);
    return i < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / i, this.y = t.y / i, this.z = t.z / i), this;
  }
  setAxisAngleFromRotationMatrix(t) {
    let i, e, s, n;
    const a = t.elements, o = a[0], l = a[4], c = a[8], u = a[1], d = a[5], m = a[9], y = a[2], x = a[6], g = a[10];
    if (Math.abs(l - u) < 0.01 && Math.abs(c - y) < 0.01 && Math.abs(m - x) < 0.01) {
      if (Math.abs(l + u) < 0.1 && Math.abs(c + y) < 0.1 && Math.abs(m + x) < 0.1 && Math.abs(o + d + g - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      i = Math.PI;
      const b = (o + 1) / 2, M = (d + 1) / 2, S = (g + 1) / 2, F = (l + u) / 4, _ = (c + y) / 4, A = (m + x) / 4;
      return b > M && b > S ? b < 0.01 ? (e = 0, s = 0.707106781, n = 0.707106781) : (e = Math.sqrt(b), s = F / e, n = _ / e) : M > S ? M < 0.01 ? (e = 0.707106781, s = 0, n = 0.707106781) : (s = Math.sqrt(M), e = F / s, n = A / s) : S < 0.01 ? (e = 0.707106781, s = 0.707106781, n = 0) : (n = Math.sqrt(S), e = _ / n, s = A / n), this.set(e, s, n, i), this;
    }
    let w = Math.sqrt((x - m) * (x - m) + (c - y) * (c - y) + (u - l) * (u - l));
    return Math.abs(w) < 1e-3 && (w = 1), this.x = (x - m) / w, this.y = (c - y) / w, this.z = (u - l) / w, this.w = Math.acos((o + d + g - 1) / 2), this;
  }
  setFromMatrixPosition(t) {
    const i = t.elements;
    return this.x = i[12], this.y = i[13], this.z = i[14], this.w = i[15], this;
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
  }
  clamp(t, i) {
    return this.x = T(this.x, t.x, i.x), this.y = T(this.y, t.y, i.y), this.z = T(this.z, t.z, i.z), this.w = T(this.w, t.w, i.w), this;
  }
  clampScalar(t, i) {
    return this.x = T(this.x, t, i), this.y = T(this.y, t, i), this.z = T(this.z, t, i), this.w = T(this.w, t, i), this;
  }
  clampLength(t, i) {
    const e = this.length();
    return this.divideScalar(e || 1).multiplyScalar(T(e, t, i));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, i) {
    return this.x += (t.x - this.x) * i, this.y += (t.y - this.y) * i, this.z += (t.z - this.z) * i, this.w += (t.w - this.w) * i, this;
  }
  lerpVectors(t, i, e) {
    return this.x = t.x + (i.x - t.x) * e, this.y = t.y + (i.y - t.y) * e, this.z = t.z + (i.z - t.z) * e, this.w = t.w + (i.w - t.w) * e, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
  }
  fromArray(t, i = 0) {
    return this.x = t[i], this.y = t[i + 1], this.z = t[i + 2], this.w = t[i + 3], this;
  }
  toArray(t = [], i = 0) {
    return t[i] = this.x, t[i + 1] = this.y, t[i + 2] = this.z, t[i + 3] = this.w, t;
  }
  fromBufferAttribute(t, i) {
    return this.x = t.getX(i), this.y = t.getY(i), this.z = t.getZ(i), this.w = t.getW(i), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class ts extends si {
  constructor(t = 1, i = 1, e = {}) {
    super(), this.isRenderTarget = !0, this.width = t, this.height = i, this.depth = 1, this.scissor = new j(0, 0, t, i), this.scissorTest = !1, this.viewport = new j(0, 0, t, i);
    const s = { width: t, height: i, depth: 1 };
    e = Object.assign({
      generateMipmaps: !1,
      internalFormat: null,
      minFilter: 1006,
      depthBuffer: !0,
      stencilBuffer: !1,
      resolveDepthBuffer: !0,
      resolveStencilBuffer: !0,
      depthTexture: null,
      samples: 0,
      count: 1
    }, e);
    const n = new Z(s, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.colorSpace);
    n.flipY = !1, n.generateMipmaps = e.generateMipmaps, n.internalFormat = e.internalFormat, this.textures = [];
    const r = e.count;
    for (let h = 0; h < r; h++)
      this.textures[h] = n.clone(), this.textures[h].isRenderTargetTexture = !0, this.textures[h].renderTarget = this;
    this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = e.depthTexture, this.samples = e.samples;
  }
  get texture() {
    return this.textures[0];
  }
  set texture(t) {
    this.textures[0] = t;
  }
  set depthTexture(t) {
    this._depthTexture !== null && (this._depthTexture.renderTarget = null), t !== null && (t.renderTarget = this), this._depthTexture = t;
  }
  get depthTexture() {
    return this._depthTexture;
  }
  setSize(t, i, e = 1) {
    if (this.width !== t || this.height !== i || this.depth !== e) {
      this.width = t, this.height = i, this.depth = e;
      for (let s = 0, n = this.textures.length; s < n; s++)
        this.textures[s].image.width = t, this.textures[s].image.height = i, this.textures[s].image.depth = e;
      this.dispose();
    }
    this.viewport.set(0, 0, t, i), this.scissor.set(0, 0, t, i);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    this.width = t.width, this.height = t.height, this.depth = t.depth, this.scissor.copy(t.scissor), this.scissorTest = t.scissorTest, this.viewport.copy(t.viewport), this.textures.length = 0;
    for (let e = 0, s = t.textures.length; e < s; e++)
      this.textures[e] = t.textures[e].clone(), this.textures[e].isRenderTargetTexture = !0, this.textures[e].renderTarget = this;
    const i = Object.assign({}, t.texture.image);
    return this.texture.source = new Fe(i), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, this.resolveDepthBuffer = t.resolveDepthBuffer, this.resolveStencilBuffer = t.resolveStencilBuffer, t.depthTexture !== null && (this.depthTexture = t.depthTexture.clone()), this.samples = t.samples, this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class is extends ts {
  constructor(t = 1, i = 1, e = {}) {
    super(t, i, e), this.isWebGLRenderTarget = !0;
  }
}
class Ca extends Z {
  constructor(t = null, i = 1, e = 1, s = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: t, width: i, height: e, depth: s }, this.magFilter = 1003, this.minFilter = 1003, this.wrapR = 1001, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = /* @__PURE__ */ new Set();
  }
  addLayerUpdate(t) {
    this.layerUpdates.add(t);
  }
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
class ni {
  constructor(t = 0, i = 0, e = 0, s = 1) {
    this.isQuaternion = !0, this._x = t, this._y = i, this._z = e, this._w = s;
  }
  static slerpFlat(t, i, e, s, n, r, h) {
    let a = e[s + 0], o = e[s + 1], l = e[s + 2], c = e[s + 3];
    const u = n[r + 0], d = n[r + 1], m = n[r + 2], y = n[r + 3];
    if (h === 0) {
      t[i + 0] = a, t[i + 1] = o, t[i + 2] = l, t[i + 3] = c;
      return;
    }
    if (h === 1) {
      t[i + 0] = u, t[i + 1] = d, t[i + 2] = m, t[i + 3] = y;
      return;
    }
    if (c !== y || a !== u || o !== d || l !== m) {
      let x = 1 - h;
      const g = a * u + o * d + l * m + c * y, w = g >= 0 ? 1 : -1, b = 1 - g * g;
      if (b > Number.EPSILON) {
        const S = Math.sqrt(b), F = Math.atan2(S, g * w);
        x = Math.sin(x * F) / S, h = Math.sin(h * F) / S;
      }
      const M = h * w;
      if (a = a * x + u * M, o = o * x + d * M, l = l * x + m * M, c = c * x + y * M, x === 1 - h) {
        const S = 1 / Math.sqrt(a * a + o * o + l * l + c * c);
        a *= S, o *= S, l *= S, c *= S;
      }
    }
    t[i] = a, t[i + 1] = o, t[i + 2] = l, t[i + 3] = c;
  }
  static multiplyQuaternionsFlat(t, i, e, s, n, r) {
    const h = e[s], a = e[s + 1], o = e[s + 2], l = e[s + 3], c = n[r], u = n[r + 1], d = n[r + 2], m = n[r + 3];
    return t[i] = h * m + l * c + a * d - o * u, t[i + 1] = a * m + l * u + o * c - h * d, t[i + 2] = o * m + l * d + h * u - a * c, t[i + 3] = l * m - h * c - a * u - o * d, t;
  }
  get x() {
    return this._x;
  }
  set x(t) {
    this._x = t, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(t) {
    this._y = t, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(t) {
    this._z = t, this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(t) {
    this._w = t, this._onChangeCallback();
  }
  set(t, i, e, s) {
    return this._x = t, this._y = i, this._z = e, this._w = s, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(t) {
    return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
  }
  setFromEuler(t, i = !0) {
    const e = t._x, s = t._y, n = t._z, r = t._order, h = Math.cos, a = Math.sin, o = h(e / 2), l = h(s / 2), c = h(n / 2), u = a(e / 2), d = a(s / 2), m = a(n / 2);
    switch (r) {
      case "XYZ":
        this._x = u * l * c + o * d * m, this._y = o * d * c - u * l * m, this._z = o * l * m + u * d * c, this._w = o * l * c - u * d * m;
        break;
      case "YXZ":
        this._x = u * l * c + o * d * m, this._y = o * d * c - u * l * m, this._z = o * l * m - u * d * c, this._w = o * l * c + u * d * m;
        break;
      case "ZXY":
        this._x = u * l * c - o * d * m, this._y = o * d * c + u * l * m, this._z = o * l * m + u * d * c, this._w = o * l * c - u * d * m;
        break;
      case "ZYX":
        this._x = u * l * c - o * d * m, this._y = o * d * c + u * l * m, this._z = o * l * m - u * d * c, this._w = o * l * c + u * d * m;
        break;
      case "YZX":
        this._x = u * l * c + o * d * m, this._y = o * d * c + u * l * m, this._z = o * l * m - u * d * c, this._w = o * l * c - u * d * m;
        break;
      case "XZY":
        this._x = u * l * c - o * d * m, this._y = o * d * c - u * l * m, this._z = o * l * m + u * d * c, this._w = o * l * c + u * d * m;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + r);
    }
    return i === !0 && this._onChangeCallback(), this;
  }
  setFromAxisAngle(t, i) {
    const e = i / 2, s = Math.sin(e);
    return this._x = t.x * s, this._y = t.y * s, this._z = t.z * s, this._w = Math.cos(e), this._onChangeCallback(), this;
  }
  setFromRotationMatrix(t) {
    const i = t.elements, e = i[0], s = i[4], n = i[8], r = i[1], h = i[5], a = i[9], o = i[2], l = i[6], c = i[10], u = e + h + c;
    if (u > 0) {
      const d = 0.5 / Math.sqrt(u + 1);
      this._w = 0.25 / d, this._x = (l - a) * d, this._y = (n - o) * d, this._z = (r - s) * d;
    } else if (e > h && e > c) {
      const d = 2 * Math.sqrt(1 + e - h - c);
      this._w = (l - a) / d, this._x = 0.25 * d, this._y = (s + r) / d, this._z = (n + o) / d;
    } else if (h > c) {
      const d = 2 * Math.sqrt(1 + h - e - c);
      this._w = (n - o) / d, this._x = (s + r) / d, this._y = 0.25 * d, this._z = (a + l) / d;
    } else {
      const d = 2 * Math.sqrt(1 + c - e - h);
      this._w = (r - s) / d, this._x = (n + o) / d, this._y = (a + l) / d, this._z = 0.25 * d;
    }
    return this._onChangeCallback(), this;
  }
  setFromUnitVectors(t, i) {
    let e = t.dot(i) + 1;
    return e < Number.EPSILON ? (e = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = e) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = e)) : (this._x = t.y * i.z - t.z * i.y, this._y = t.z * i.x - t.x * i.z, this._z = t.x * i.y - t.y * i.x, this._w = e), this.normalize();
  }
  angleTo(t) {
    return 2 * Math.acos(Math.abs(T(this.dot(t), -1, 1)));
  }
  rotateTowards(t, i) {
    const e = this.angleTo(t);
    if (e === 0) return this;
    const s = Math.min(1, i / e);
    return this.slerp(t, s), this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  dot(t) {
    return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let t = this.length();
    return t === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
  }
  multiply(t) {
    return this.multiplyQuaternions(this, t);
  }
  premultiply(t) {
    return this.multiplyQuaternions(t, this);
  }
  multiplyQuaternions(t, i) {
    const e = t._x, s = t._y, n = t._z, r = t._w, h = i._x, a = i._y, o = i._z, l = i._w;
    return this._x = e * l + r * h + s * o - n * a, this._y = s * l + r * a + n * h - e * o, this._z = n * l + r * o + e * a - s * h, this._w = r * l - e * h - s * a - n * o, this._onChangeCallback(), this;
  }
  slerp(t, i) {
    if (i === 0) return this;
    if (i === 1) return this.copy(t);
    const e = this._x, s = this._y, n = this._z, r = this._w;
    let h = r * t._w + e * t._x + s * t._y + n * t._z;
    if (h < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, h = -h) : this.copy(t), h >= 1)
      return this._w = r, this._x = e, this._y = s, this._z = n, this;
    const a = 1 - h * h;
    if (a <= Number.EPSILON) {
      const d = 1 - i;
      return this._w = d * r + i * this._w, this._x = d * e + i * this._x, this._y = d * s + i * this._y, this._z = d * n + i * this._z, this.normalize(), this;
    }
    const o = Math.sqrt(a), l = Math.atan2(o, h), c = Math.sin((1 - i) * l) / o, u = Math.sin(i * l) / o;
    return this._w = r * c + this._w * u, this._x = e * c + this._x * u, this._y = s * c + this._y * u, this._z = n * c + this._z * u, this._onChangeCallback(), this;
  }
  slerpQuaternions(t, i, e) {
    return this.copy(t).slerp(i, e);
  }
  random() {
    const t = 2 * Math.PI * Math.random(), i = 2 * Math.PI * Math.random(), e = Math.random(), s = Math.sqrt(1 - e), n = Math.sqrt(e);
    return this.set(
      s * Math.sin(t),
      s * Math.cos(t),
      n * Math.sin(i),
      n * Math.cos(i)
    );
  }
  equals(t) {
    return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
  }
  fromArray(t, i = 0) {
    return this._x = t[i], this._y = t[i + 1], this._z = t[i + 2], this._w = t[i + 3], this._onChangeCallback(), this;
  }
  toArray(t = [], i = 0) {
    return t[i] = this._x, t[i + 1] = this._y, t[i + 2] = this._z, t[i + 3] = this._w, t;
  }
  fromBufferAttribute(t, i) {
    return this._x = t.getX(i), this._y = t.getY(i), this._z = t.getZ(i), this._w = t.getW(i), this._onChangeCallback(), this;
  }
  toJSON() {
    return this.toArray();
  }
  _onChange(t) {
    return this._onChangeCallback = t, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class f {
  constructor(t = 0, i = 0, e = 0) {
    f.prototype.isVector3 = !0, this.x = t, this.y = i, this.z = e;
  }
  set(t, i, e) {
    return e === void 0 && (e = this.z), this.x = t, this.y = i, this.z = e, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this.z = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setZ(t) {
    return this.z = t, this;
  }
  setComponent(t, i) {
    switch (t) {
      case 0:
        this.x = i;
        break;
      case 1:
        this.y = i;
        break;
      case 2:
        this.z = i;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this.z += t.z, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this.z += t, this;
  }
  addVectors(t, i) {
    return this.x = t.x + i.x, this.y = t.y + i.y, this.z = t.z + i.z, this;
  }
  addScaledVector(t, i) {
    return this.x += t.x * i, this.y += t.y * i, this.z += t.z * i, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this.z -= t, this;
  }
  subVectors(t, i) {
    return this.x = t.x - i.x, this.y = t.y - i.y, this.z = t.z - i.z, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this.z *= t.z, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this;
  }
  multiplyVectors(t, i) {
    return this.x = t.x * i.x, this.y = t.y * i.y, this.z = t.z * i.z, this;
  }
  applyEuler(t) {
    return this.applyQuaternion(he.setFromEuler(t));
  }
  applyAxisAngle(t, i) {
    return this.applyQuaternion(he.setFromAxisAngle(t, i));
  }
  applyMatrix3(t) {
    const i = this.x, e = this.y, s = this.z, n = t.elements;
    return this.x = n[0] * i + n[3] * e + n[6] * s, this.y = n[1] * i + n[4] * e + n[7] * s, this.z = n[2] * i + n[5] * e + n[8] * s, this;
  }
  applyNormalMatrix(t) {
    return this.applyMatrix3(t).normalize();
  }
  applyMatrix4(t) {
    const i = this.x, e = this.y, s = this.z, n = t.elements, r = 1 / (n[3] * i + n[7] * e + n[11] * s + n[15]);
    return this.x = (n[0] * i + n[4] * e + n[8] * s + n[12]) * r, this.y = (n[1] * i + n[5] * e + n[9] * s + n[13]) * r, this.z = (n[2] * i + n[6] * e + n[10] * s + n[14]) * r, this;
  }
  applyQuaternion(t) {
    const i = this.x, e = this.y, s = this.z, n = t.x, r = t.y, h = t.z, a = t.w, o = 2 * (r * s - h * e), l = 2 * (h * i - n * s), c = 2 * (n * e - r * i);
    return this.x = i + a * o + r * c - h * l, this.y = e + a * l + h * o - n * c, this.z = s + a * c + n * l - r * o, this;
  }
  project(t) {
    return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
  }
  unproject(t) {
    return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
  }
  transformDirection(t) {
    const i = this.x, e = this.y, s = this.z, n = t.elements;
    return this.x = n[0] * i + n[4] * e + n[8] * s, this.y = n[1] * i + n[5] * e + n[9] * s, this.z = n[2] * i + n[6] * e + n[10] * s, this.normalize();
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
  }
  clamp(t, i) {
    return this.x = T(this.x, t.x, i.x), this.y = T(this.y, t.y, i.y), this.z = T(this.z, t.z, i.z), this;
  }
  clampScalar(t, i) {
    return this.x = T(this.x, t, i), this.y = T(this.y, t, i), this.z = T(this.z, t, i), this;
  }
  clampLength(t, i) {
    const e = this.length();
    return this.divideScalar(e || 1).multiplyScalar(T(e, t, i));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z;
  }
  // TODO lengthSquared?
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, i) {
    return this.x += (t.x - this.x) * i, this.y += (t.y - this.y) * i, this.z += (t.z - this.z) * i, this;
  }
  lerpVectors(t, i, e) {
    return this.x = t.x + (i.x - t.x) * e, this.y = t.y + (i.y - t.y) * e, this.z = t.z + (i.z - t.z) * e, this;
  }
  cross(t) {
    return this.crossVectors(this, t);
  }
  crossVectors(t, i) {
    const e = t.x, s = t.y, n = t.z, r = i.x, h = i.y, a = i.z;
    return this.x = s * a - n * h, this.y = n * r - e * a, this.z = e * h - s * r, this;
  }
  projectOnVector(t) {
    const i = t.lengthSq();
    if (i === 0) return this.set(0, 0, 0);
    const e = t.dot(this) / i;
    return this.copy(t).multiplyScalar(e);
  }
  projectOnPlane(t) {
    return Bi.copy(this).projectOnVector(t), this.sub(Bi);
  }
  reflect(t) {
    return this.sub(Bi.copy(t).multiplyScalar(2 * this.dot(t)));
  }
  angleTo(t) {
    const i = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (i === 0) return Math.PI / 2;
    const e = this.dot(t) / i;
    return Math.acos(T(e, -1, 1));
  }
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  distanceToSquared(t) {
    const i = this.x - t.x, e = this.y - t.y, s = this.z - t.z;
    return i * i + e * e + s * s;
  }
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
  }
  setFromSpherical(t) {
    return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
  }
  setFromSphericalCoords(t, i, e) {
    const s = Math.sin(i) * t;
    return this.x = s * Math.sin(e), this.y = Math.cos(i) * t, this.z = s * Math.cos(e), this;
  }
  setFromCylindrical(t) {
    return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
  }
  setFromCylindricalCoords(t, i, e) {
    return this.x = t * Math.sin(i), this.y = e, this.z = t * Math.cos(i), this;
  }
  setFromMatrixPosition(t) {
    const i = t.elements;
    return this.x = i[12], this.y = i[13], this.z = i[14], this;
  }
  setFromMatrixScale(t) {
    const i = this.setFromMatrixColumn(t, 0).length(), e = this.setFromMatrixColumn(t, 1).length(), s = this.setFromMatrixColumn(t, 2).length();
    return this.x = i, this.y = e, this.z = s, this;
  }
  setFromMatrixColumn(t, i) {
    return this.fromArray(t.elements, i * 4);
  }
  setFromMatrix3Column(t, i) {
    return this.fromArray(t.elements, i * 3);
  }
  setFromEuler(t) {
    return this.x = t._x, this.y = t._y, this.z = t._z, this;
  }
  setFromColor(t) {
    return this.x = t.r, this.y = t.g, this.z = t.b, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z;
  }
  fromArray(t, i = 0) {
    return this.x = t[i], this.y = t[i + 1], this.z = t[i + 2], this;
  }
  toArray(t = [], i = 0) {
    return t[i] = this.x, t[i + 1] = this.y, t[i + 2] = this.z, t;
  }
  fromBufferAttribute(t, i) {
    return this.x = t.getX(i), this.y = t.getY(i), this.z = t.getZ(i), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  randomDirection() {
    const t = Math.random() * Math.PI * 2, i = Math.random() * 2 - 1, e = Math.sqrt(1 - i * i);
    return this.x = e * Math.cos(t), this.y = i, this.z = e * Math.sin(t), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const Bi = /* @__PURE__ */ new f(), he = /* @__PURE__ */ new ni();
class ri {
  constructor(t = new f(1 / 0, 1 / 0, 1 / 0), i = new f(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = t, this.max = i;
  }
  set(t, i) {
    return this.min.copy(t), this.max.copy(i), this;
  }
  setFromArray(t) {
    this.makeEmpty();
    for (let i = 0, e = t.length; i < e; i += 3)
      this.expandByPoint(K.fromArray(t, i));
    return this;
  }
  setFromBufferAttribute(t) {
    this.makeEmpty();
    for (let i = 0, e = t.count; i < e; i++)
      this.expandByPoint(K.fromBufferAttribute(t, i));
    return this;
  }
  setFromPoints(t) {
    this.makeEmpty();
    for (let i = 0, e = t.length; i < e; i++)
      this.expandByPoint(t[i]);
    return this;
  }
  setFromCenterAndSize(t, i) {
    const e = K.copy(i).multiplyScalar(0.5);
    return this.min.copy(t).sub(e), this.max.copy(t).add(e), this;
  }
  setFromObject(t, i = !1) {
    return this.makeEmpty(), this.expandByObject(t, i);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    return this.min.copy(t.min), this.max.copy(t.max), this;
  }
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(t) {
    return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(t) {
    return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
  }
  expandByPoint(t) {
    return this.min.min(t), this.max.max(t), this;
  }
  expandByVector(t) {
    return this.min.sub(t), this.max.add(t), this;
  }
  expandByScalar(t) {
    return this.min.addScalar(-t), this.max.addScalar(t), this;
  }
  expandByObject(t, i = !1) {
    t.updateWorldMatrix(!1, !1);
    const e = t.geometry;
    if (e !== void 0) {
      const n = e.getAttribute("position");
      if (i === !0 && n !== void 0 && t.isInstancedMesh !== !0)
        for (let r = 0, h = n.count; r < h; r++)
          t.isMesh === !0 ? t.getVertexPosition(r, K) : K.fromBufferAttribute(n, r), K.applyMatrix4(t.matrixWorld), this.expandByPoint(K);
      else
        t.boundingBox !== void 0 ? (t.boundingBox === null && t.computeBoundingBox(), oi.copy(t.boundingBox)) : (e.boundingBox === null && e.computeBoundingBox(), oi.copy(e.boundingBox)), oi.applyMatrix4(t.matrixWorld), this.union(oi);
    }
    const s = t.children;
    for (let n = 0, r = s.length; n < r; n++)
      this.expandByObject(s[n], i);
    return this;
  }
  containsPoint(t) {
    return t.x >= this.min.x && t.x <= this.max.x && t.y >= this.min.y && t.y <= this.max.y && t.z >= this.min.z && t.z <= this.max.z;
  }
  containsBox(t) {
    return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
  }
  getParameter(t, i) {
    return i.set(
      (t.x - this.min.x) / (this.max.x - this.min.x),
      (t.y - this.min.y) / (this.max.y - this.min.y),
      (t.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(t) {
    return t.max.x >= this.min.x && t.min.x <= this.max.x && t.max.y >= this.min.y && t.min.y <= this.max.y && t.max.z >= this.min.z && t.min.z <= this.max.z;
  }
  intersectsSphere(t) {
    return this.clampPoint(t.center, K), K.distanceToSquared(t.center) <= t.radius * t.radius;
  }
  intersectsPlane(t) {
    let i, e;
    return t.normal.x > 0 ? (i = t.normal.x * this.min.x, e = t.normal.x * this.max.x) : (i = t.normal.x * this.max.x, e = t.normal.x * this.min.x), t.normal.y > 0 ? (i += t.normal.y * this.min.y, e += t.normal.y * this.max.y) : (i += t.normal.y * this.max.y, e += t.normal.y * this.min.y), t.normal.z > 0 ? (i += t.normal.z * this.min.z, e += t.normal.z * this.max.z) : (i += t.normal.z * this.max.z, e += t.normal.z * this.min.z), i <= -t.constant && e >= -t.constant;
  }
  intersectsTriangle(t) {
    if (this.isEmpty())
      return !1;
    this.getCenter(Zt), li.subVectors(this.max, Zt), Pt.subVectors(t.a, Zt), Lt.subVectors(t.b, Zt), Ot.subVectors(t.c, Zt), Mt.subVectors(Lt, Pt), wt.subVectors(Ot, Lt), Tt.subVectors(Pt, Ot);
    let i = [
      0,
      -Mt.z,
      Mt.y,
      0,
      -wt.z,
      wt.y,
      0,
      -Tt.z,
      Tt.y,
      Mt.z,
      0,
      -Mt.x,
      wt.z,
      0,
      -wt.x,
      Tt.z,
      0,
      -Tt.x,
      -Mt.y,
      Mt.x,
      0,
      -wt.y,
      wt.x,
      0,
      -Tt.y,
      Tt.x,
      0
    ];
    return !vi(i, Pt, Lt, Ot, li) || (i = [1, 0, 0, 0, 1, 0, 0, 0, 1], !vi(i, Pt, Lt, Ot, li)) ? !1 : (ci.crossVectors(Mt, wt), i = [ci.x, ci.y, ci.z], vi(i, Pt, Lt, Ot, li));
  }
  clampPoint(t, i) {
    return i.copy(t).clamp(this.min, this.max);
  }
  distanceToPoint(t) {
    return this.clampPoint(t, K).distanceTo(t);
  }
  getBoundingSphere(t) {
    return this.isEmpty() ? t.makeEmpty() : (this.getCenter(t.center), t.radius = this.getSize(K).length() * 0.5), t;
  }
  intersect(t) {
    return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
  }
  union(t) {
    return this.min.min(t.min), this.max.max(t.max), this;
  }
  applyMatrix4(t) {
    return this.isEmpty() ? this : (ot[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), ot[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), ot[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), ot[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), ot[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), ot[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), ot[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), ot[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(ot), this);
  }
  translate(t) {
    return this.min.add(t), this.max.add(t), this;
  }
  equals(t) {
    return t.min.equals(this.min) && t.max.equals(this.max);
  }
}
const ot = [
  /* @__PURE__ */ new f(),
  /* @__PURE__ */ new f(),
  /* @__PURE__ */ new f(),
  /* @__PURE__ */ new f(),
  /* @__PURE__ */ new f(),
  /* @__PURE__ */ new f(),
  /* @__PURE__ */ new f(),
  /* @__PURE__ */ new f()
], K = /* @__PURE__ */ new f(), oi = /* @__PURE__ */ new ri(), Pt = /* @__PURE__ */ new f(), Lt = /* @__PURE__ */ new f(), Ot = /* @__PURE__ */ new f(), Mt = /* @__PURE__ */ new f(), wt = /* @__PURE__ */ new f(), Tt = /* @__PURE__ */ new f(), Zt = /* @__PURE__ */ new f(), li = /* @__PURE__ */ new f(), ci = /* @__PURE__ */ new f(), Ct = /* @__PURE__ */ new f();
function vi(p, t, i, e, s) {
  for (let n = 0, r = p.length - 3; n <= r; n += 3) {
    Ct.fromArray(p, n);
    const h = s.x * Math.abs(Ct.x) + s.y * Math.abs(Ct.y) + s.z * Math.abs(Ct.z), a = t.dot(Ct), o = i.dot(Ct), l = e.dot(Ct);
    if (Math.max(-Math.max(a, o, l), Math.min(a, o, l)) > h)
      return !1;
  }
  return !0;
}
const es = /* @__PURE__ */ new ri(), Jt = /* @__PURE__ */ new f(), Ri = /* @__PURE__ */ new f();
class $i {
  constructor(t = new f(), i = -1) {
    this.isSphere = !0, this.center = t, this.radius = i;
  }
  set(t, i) {
    return this.center.copy(t), this.radius = i, this;
  }
  setFromPoints(t, i) {
    const e = this.center;
    i !== void 0 ? e.copy(i) : es.setFromPoints(t).getCenter(e);
    let s = 0;
    for (let n = 0, r = t.length; n < r; n++)
      s = Math.max(s, e.distanceToSquared(t[n]));
    return this.radius = Math.sqrt(s), this;
  }
  copy(t) {
    return this.center.copy(t.center), this.radius = t.radius, this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  containsPoint(t) {
    return t.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(t) {
    return t.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(t) {
    const i = this.radius + t.radius;
    return t.center.distanceToSquared(this.center) <= i * i;
  }
  intersectsBox(t) {
    return t.intersectsSphere(this);
  }
  intersectsPlane(t) {
    return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(t, i) {
    const e = this.center.distanceToSquared(t);
    return i.copy(t), e > this.radius * this.radius && (i.sub(this.center).normalize(), i.multiplyScalar(this.radius).add(this.center)), i;
  }
  getBoundingBox(t) {
    return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
  }
  applyMatrix4(t) {
    return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
  }
  translate(t) {
    return this.center.add(t), this;
  }
  expandByPoint(t) {
    if (this.isEmpty())
      return this.center.copy(t), this.radius = 0, this;
    Jt.subVectors(t, this.center);
    const i = Jt.lengthSq();
    if (i > this.radius * this.radius) {
      const e = Math.sqrt(i), s = (e - this.radius) * 0.5;
      this.center.addScaledVector(Jt, s / e), this.radius += s;
    }
    return this;
  }
  union(t) {
    return t.isEmpty() ? this : this.isEmpty() ? (this.copy(t), this) : (this.center.equals(t.center) === !0 ? this.radius = Math.max(this.radius, t.radius) : (Ri.subVectors(t.center, this.center).setLength(t.radius), this.expandByPoint(Jt.copy(t.center).add(Ri)), this.expandByPoint(Jt.copy(t.center).sub(Ri))), this);
  }
  equals(t) {
    return t.center.equals(this.center) && t.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const lt = /* @__PURE__ */ new f(), Ei = /* @__PURE__ */ new f(), ui = /* @__PURE__ */ new f(), bt = /* @__PURE__ */ new f(), ki = /* @__PURE__ */ new f(), pi = /* @__PURE__ */ new f(), Ii = /* @__PURE__ */ new f();
class ss {
  constructor(t = new f(), i = new f(0, 0, -1)) {
    this.origin = t, this.direction = i;
  }
  set(t, i) {
    return this.origin.copy(t), this.direction.copy(i), this;
  }
  copy(t) {
    return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
  }
  at(t, i) {
    return i.copy(this.origin).addScaledVector(this.direction, t);
  }
  lookAt(t) {
    return this.direction.copy(t).sub(this.origin).normalize(), this;
  }
  recast(t) {
    return this.origin.copy(this.at(t, lt)), this;
  }
  closestPointToPoint(t, i) {
    i.subVectors(t, this.origin);
    const e = i.dot(this.direction);
    return e < 0 ? i.copy(this.origin) : i.copy(this.origin).addScaledVector(this.direction, e);
  }
  distanceToPoint(t) {
    return Math.sqrt(this.distanceSqToPoint(t));
  }
  distanceSqToPoint(t) {
    const i = lt.subVectors(t, this.origin).dot(this.direction);
    return i < 0 ? this.origin.distanceToSquared(t) : (lt.copy(this.origin).addScaledVector(this.direction, i), lt.distanceToSquared(t));
  }
  distanceSqToSegment(t, i, e, s) {
    Ei.copy(t).add(i).multiplyScalar(0.5), ui.copy(i).sub(t).normalize(), bt.copy(this.origin).sub(Ei);
    const n = t.distanceTo(i) * 0.5, r = -this.direction.dot(ui), h = bt.dot(this.direction), a = -bt.dot(ui), o = bt.lengthSq(), l = Math.abs(1 - r * r);
    let c, u, d, m;
    if (l > 0)
      if (c = r * a - h, u = r * h - a, m = n * l, c >= 0)
        if (u >= -m)
          if (u <= m) {
            const y = 1 / l;
            c *= y, u *= y, d = c * (c + r * u + 2 * h) + u * (r * c + u + 2 * a) + o;
          } else
            u = n, c = Math.max(0, -(r * u + h)), d = -c * c + u * (u + 2 * a) + o;
        else
          u = -n, c = Math.max(0, -(r * u + h)), d = -c * c + u * (u + 2 * a) + o;
      else
        u <= -m ? (c = Math.max(0, -(-r * n + h)), u = c > 0 ? -n : Math.min(Math.max(-n, -a), n), d = -c * c + u * (u + 2 * a) + o) : u <= m ? (c = 0, u = Math.min(Math.max(-n, -a), n), d = u * (u + 2 * a) + o) : (c = Math.max(0, -(r * n + h)), u = c > 0 ? n : Math.min(Math.max(-n, -a), n), d = -c * c + u * (u + 2 * a) + o);
    else
      u = r > 0 ? -n : n, c = Math.max(0, -(r * u + h)), d = -c * c + u * (u + 2 * a) + o;
    return e && e.copy(this.origin).addScaledVector(this.direction, c), s && s.copy(Ei).addScaledVector(ui, u), d;
  }
  intersectSphere(t, i) {
    lt.subVectors(t.center, this.origin);
    const e = lt.dot(this.direction), s = lt.dot(lt) - e * e, n = t.radius * t.radius;
    if (s > n) return null;
    const r = Math.sqrt(n - s), h = e - r, a = e + r;
    return a < 0 ? null : h < 0 ? this.at(a, i) : this.at(h, i);
  }
  intersectsSphere(t) {
    return this.distanceSqToPoint(t.center) <= t.radius * t.radius;
  }
  distanceToPlane(t) {
    const i = t.normal.dot(this.direction);
    if (i === 0)
      return t.distanceToPoint(this.origin) === 0 ? 0 : null;
    const e = -(this.origin.dot(t.normal) + t.constant) / i;
    return e >= 0 ? e : null;
  }
  intersectPlane(t, i) {
    const e = this.distanceToPlane(t);
    return e === null ? null : this.at(e, i);
  }
  intersectsPlane(t) {
    const i = t.distanceToPoint(this.origin);
    return i === 0 || t.normal.dot(this.direction) * i < 0;
  }
  intersectBox(t, i) {
    let e, s, n, r, h, a;
    const o = 1 / this.direction.x, l = 1 / this.direction.y, c = 1 / this.direction.z, u = this.origin;
    return o >= 0 ? (e = (t.min.x - u.x) * o, s = (t.max.x - u.x) * o) : (e = (t.max.x - u.x) * o, s = (t.min.x - u.x) * o), l >= 0 ? (n = (t.min.y - u.y) * l, r = (t.max.y - u.y) * l) : (n = (t.max.y - u.y) * l, r = (t.min.y - u.y) * l), e > r || n > s || ((n > e || isNaN(e)) && (e = n), (r < s || isNaN(s)) && (s = r), c >= 0 ? (h = (t.min.z - u.z) * c, a = (t.max.z - u.z) * c) : (h = (t.max.z - u.z) * c, a = (t.min.z - u.z) * c), e > a || h > s) || ((h > e || e !== e) && (e = h), (a < s || s !== s) && (s = a), s < 0) ? null : this.at(e >= 0 ? e : s, i);
  }
  intersectsBox(t) {
    return this.intersectBox(t, lt) !== null;
  }
  intersectTriangle(t, i, e, s, n) {
    ki.subVectors(i, t), pi.subVectors(e, t), Ii.crossVectors(ki, pi);
    let r = this.direction.dot(Ii), h;
    if (r > 0) {
      if (s) return null;
      h = 1;
    } else if (r < 0)
      h = -1, r = -r;
    else
      return null;
    bt.subVectors(this.origin, t);
    const a = h * this.direction.dot(pi.crossVectors(bt, pi));
    if (a < 0)
      return null;
    const o = h * this.direction.dot(ki.cross(bt));
    if (o < 0 || a + o > r)
      return null;
    const l = -h * bt.dot(Ii);
    return l < 0 ? null : this.at(l / r, n);
  }
  applyMatrix4(t) {
    return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
  }
  equals(t) {
    return t.origin.equals(this.origin) && t.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class O {
  constructor(t, i, e, s, n, r, h, a, o, l, c, u, d, m, y, x) {
    O.prototype.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], t !== void 0 && this.set(t, i, e, s, n, r, h, a, o, l, c, u, d, m, y, x);
  }
  set(t, i, e, s, n, r, h, a, o, l, c, u, d, m, y, x) {
    const g = this.elements;
    return g[0] = t, g[4] = i, g[8] = e, g[12] = s, g[1] = n, g[5] = r, g[9] = h, g[13] = a, g[2] = o, g[6] = l, g[10] = c, g[14] = u, g[3] = d, g[7] = m, g[11] = y, g[15] = x, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  clone() {
    return new O().fromArray(this.elements);
  }
  copy(t) {
    const i = this.elements, e = t.elements;
    return i[0] = e[0], i[1] = e[1], i[2] = e[2], i[3] = e[3], i[4] = e[4], i[5] = e[5], i[6] = e[6], i[7] = e[7], i[8] = e[8], i[9] = e[9], i[10] = e[10], i[11] = e[11], i[12] = e[12], i[13] = e[13], i[14] = e[14], i[15] = e[15], this;
  }
  copyPosition(t) {
    const i = this.elements, e = t.elements;
    return i[12] = e[12], i[13] = e[13], i[14] = e[14], this;
  }
  setFromMatrix3(t) {
    const i = t.elements;
    return this.set(
      i[0],
      i[3],
      i[6],
      0,
      i[1],
      i[4],
      i[7],
      0,
      i[2],
      i[5],
      i[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractBasis(t, i, e) {
    return t.setFromMatrixColumn(this, 0), i.setFromMatrixColumn(this, 1), e.setFromMatrixColumn(this, 2), this;
  }
  makeBasis(t, i, e) {
    return this.set(
      t.x,
      i.x,
      e.x,
      0,
      t.y,
      i.y,
      e.y,
      0,
      t.z,
      i.z,
      e.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractRotation(t) {
    const i = this.elements, e = t.elements, s = 1 / Nt.setFromMatrixColumn(t, 0).length(), n = 1 / Nt.setFromMatrixColumn(t, 1).length(), r = 1 / Nt.setFromMatrixColumn(t, 2).length();
    return i[0] = e[0] * s, i[1] = e[1] * s, i[2] = e[2] * s, i[3] = 0, i[4] = e[4] * n, i[5] = e[5] * n, i[6] = e[6] * n, i[7] = 0, i[8] = e[8] * r, i[9] = e[9] * r, i[10] = e[10] * r, i[11] = 0, i[12] = 0, i[13] = 0, i[14] = 0, i[15] = 1, this;
  }
  makeRotationFromEuler(t) {
    const i = this.elements, e = t.x, s = t.y, n = t.z, r = Math.cos(e), h = Math.sin(e), a = Math.cos(s), o = Math.sin(s), l = Math.cos(n), c = Math.sin(n);
    if (t.order === "XYZ") {
      const u = r * l, d = r * c, m = h * l, y = h * c;
      i[0] = a * l, i[4] = -a * c, i[8] = o, i[1] = d + m * o, i[5] = u - y * o, i[9] = -h * a, i[2] = y - u * o, i[6] = m + d * o, i[10] = r * a;
    } else if (t.order === "YXZ") {
      const u = a * l, d = a * c, m = o * l, y = o * c;
      i[0] = u + y * h, i[4] = m * h - d, i[8] = r * o, i[1] = r * c, i[5] = r * l, i[9] = -h, i[2] = d * h - m, i[6] = y + u * h, i[10] = r * a;
    } else if (t.order === "ZXY") {
      const u = a * l, d = a * c, m = o * l, y = o * c;
      i[0] = u - y * h, i[4] = -r * c, i[8] = m + d * h, i[1] = d + m * h, i[5] = r * l, i[9] = y - u * h, i[2] = -r * o, i[6] = h, i[10] = r * a;
    } else if (t.order === "ZYX") {
      const u = r * l, d = r * c, m = h * l, y = h * c;
      i[0] = a * l, i[4] = m * o - d, i[8] = u * o + y, i[1] = a * c, i[5] = y * o + u, i[9] = d * o - m, i[2] = -o, i[6] = h * a, i[10] = r * a;
    } else if (t.order === "YZX") {
      const u = r * a, d = r * o, m = h * a, y = h * o;
      i[0] = a * l, i[4] = y - u * c, i[8] = m * c + d, i[1] = c, i[5] = r * l, i[9] = -h * l, i[2] = -o * l, i[6] = d * c + m, i[10] = u - y * c;
    } else if (t.order === "XZY") {
      const u = r * a, d = r * o, m = h * a, y = h * o;
      i[0] = a * l, i[4] = -c, i[8] = o * l, i[1] = u * c + y, i[5] = r * l, i[9] = d * c - m, i[2] = m * c - d, i[6] = h * l, i[10] = y * c + u;
    }
    return i[3] = 0, i[7] = 0, i[11] = 0, i[12] = 0, i[13] = 0, i[14] = 0, i[15] = 1, this;
  }
  makeRotationFromQuaternion(t) {
    return this.compose(ns, t, rs);
  }
  lookAt(t, i, e) {
    const s = this.elements;
    return X.subVectors(t, i), X.lengthSq() === 0 && (X.z = 1), X.normalize(), St.crossVectors(e, X), St.lengthSq() === 0 && (Math.abs(e.z) === 1 ? X.x += 1e-4 : X.z += 1e-4, X.normalize(), St.crossVectors(e, X)), St.normalize(), di.crossVectors(X, St), s[0] = St.x, s[4] = di.x, s[8] = X.x, s[1] = St.y, s[5] = di.y, s[9] = X.y, s[2] = St.z, s[6] = di.z, s[10] = X.z, this;
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyMatrices(t, i) {
    const e = t.elements, s = i.elements, n = this.elements, r = e[0], h = e[4], a = e[8], o = e[12], l = e[1], c = e[5], u = e[9], d = e[13], m = e[2], y = e[6], x = e[10], g = e[14], w = e[3], b = e[7], M = e[11], S = e[15], F = s[0], _ = s[4], A = s[8], R = s[12], E = s[1], k = s[5], nt = s[9], I = s[13], rt = s[2], at = s[6], kt = s[10], Ft = s[14], gt = s[3], L = s[7], N = s[11], G = s[15];
    return n[0] = r * F + h * E + a * rt + o * gt, n[4] = r * _ + h * k + a * at + o * L, n[8] = r * A + h * nt + a * kt + o * N, n[12] = r * R + h * I + a * Ft + o * G, n[1] = l * F + c * E + u * rt + d * gt, n[5] = l * _ + c * k + u * at + d * L, n[9] = l * A + c * nt + u * kt + d * N, n[13] = l * R + c * I + u * Ft + d * G, n[2] = m * F + y * E + x * rt + g * gt, n[6] = m * _ + y * k + x * at + g * L, n[10] = m * A + y * nt + x * kt + g * N, n[14] = m * R + y * I + x * Ft + g * G, n[3] = w * F + b * E + M * rt + S * gt, n[7] = w * _ + b * k + M * at + S * L, n[11] = w * A + b * nt + M * kt + S * N, n[15] = w * R + b * I + M * Ft + S * G, this;
  }
  multiplyScalar(t) {
    const i = this.elements;
    return i[0] *= t, i[4] *= t, i[8] *= t, i[12] *= t, i[1] *= t, i[5] *= t, i[9] *= t, i[13] *= t, i[2] *= t, i[6] *= t, i[10] *= t, i[14] *= t, i[3] *= t, i[7] *= t, i[11] *= t, i[15] *= t, this;
  }
  determinant() {
    const t = this.elements, i = t[0], e = t[4], s = t[8], n = t[12], r = t[1], h = t[5], a = t[9], o = t[13], l = t[2], c = t[6], u = t[10], d = t[14], m = t[3], y = t[7], x = t[11], g = t[15];
    return m * (+n * a * c - s * o * c - n * h * u + e * o * u + s * h * d - e * a * d) + y * (+i * a * d - i * o * u + n * r * u - s * r * d + s * o * l - n * a * l) + x * (+i * o * c - i * h * d - n * r * c + e * r * d + n * h * l - e * o * l) + g * (-s * h * l - i * a * c + i * h * u + s * r * c - e * r * u + e * a * l);
  }
  transpose() {
    const t = this.elements;
    let i;
    return i = t[1], t[1] = t[4], t[4] = i, i = t[2], t[2] = t[8], t[8] = i, i = t[6], t[6] = t[9], t[9] = i, i = t[3], t[3] = t[12], t[12] = i, i = t[7], t[7] = t[13], t[13] = i, i = t[11], t[11] = t[14], t[14] = i, this;
  }
  setPosition(t, i, e) {
    const s = this.elements;
    return t.isVector3 ? (s[12] = t.x, s[13] = t.y, s[14] = t.z) : (s[12] = t, s[13] = i, s[14] = e), this;
  }
  invert() {
    const t = this.elements, i = t[0], e = t[1], s = t[2], n = t[3], r = t[4], h = t[5], a = t[6], o = t[7], l = t[8], c = t[9], u = t[10], d = t[11], m = t[12], y = t[13], x = t[14], g = t[15], w = c * x * o - y * u * o + y * a * d - h * x * d - c * a * g + h * u * g, b = m * u * o - l * x * o - m * a * d + r * x * d + l * a * g - r * u * g, M = l * y * o - m * c * o + m * h * d - r * y * d - l * h * g + r * c * g, S = m * c * a - l * y * a - m * h * u + r * y * u + l * h * x - r * c * x, F = i * w + e * b + s * M + n * S;
    if (F === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const _ = 1 / F;
    return t[0] = w * _, t[1] = (y * u * n - c * x * n - y * s * d + e * x * d + c * s * g - e * u * g) * _, t[2] = (h * x * n - y * a * n + y * s * o - e * x * o - h * s * g + e * a * g) * _, t[3] = (c * a * n - h * u * n - c * s * o + e * u * o + h * s * d - e * a * d) * _, t[4] = b * _, t[5] = (l * x * n - m * u * n + m * s * d - i * x * d - l * s * g + i * u * g) * _, t[6] = (m * a * n - r * x * n - m * s * o + i * x * o + r * s * g - i * a * g) * _, t[7] = (r * u * n - l * a * n + l * s * o - i * u * o - r * s * d + i * a * d) * _, t[8] = M * _, t[9] = (m * c * n - l * y * n - m * e * d + i * y * d + l * e * g - i * c * g) * _, t[10] = (r * y * n - m * h * n + m * e * o - i * y * o - r * e * g + i * h * g) * _, t[11] = (l * h * n - r * c * n - l * e * o + i * c * o + r * e * d - i * h * d) * _, t[12] = S * _, t[13] = (l * y * s - m * c * s + m * e * u - i * y * u - l * e * x + i * c * x) * _, t[14] = (m * h * s - r * y * s - m * e * a + i * y * a + r * e * x - i * h * x) * _, t[15] = (r * c * s - l * h * s + l * e * a - i * c * a - r * e * u + i * h * u) * _, this;
  }
  scale(t) {
    const i = this.elements, e = t.x, s = t.y, n = t.z;
    return i[0] *= e, i[4] *= s, i[8] *= n, i[1] *= e, i[5] *= s, i[9] *= n, i[2] *= e, i[6] *= s, i[10] *= n, i[3] *= e, i[7] *= s, i[11] *= n, this;
  }
  getMaxScaleOnAxis() {
    const t = this.elements, i = t[0] * t[0] + t[1] * t[1] + t[2] * t[2], e = t[4] * t[4] + t[5] * t[5] + t[6] * t[6], s = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
    return Math.sqrt(Math.max(i, e, s));
  }
  makeTranslation(t, i, e) {
    return t.isVector3 ? this.set(
      1,
      0,
      0,
      t.x,
      0,
      1,
      0,
      t.y,
      0,
      0,
      1,
      t.z,
      0,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      0,
      t,
      0,
      1,
      0,
      i,
      0,
      0,
      1,
      e,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationX(t) {
    const i = Math.cos(t), e = Math.sin(t);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      i,
      -e,
      0,
      0,
      e,
      i,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationY(t) {
    const i = Math.cos(t), e = Math.sin(t);
    return this.set(
      i,
      0,
      e,
      0,
      0,
      1,
      0,
      0,
      -e,
      0,
      i,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationZ(t) {
    const i = Math.cos(t), e = Math.sin(t);
    return this.set(
      i,
      -e,
      0,
      0,
      e,
      i,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationAxis(t, i) {
    const e = Math.cos(i), s = Math.sin(i), n = 1 - e, r = t.x, h = t.y, a = t.z, o = n * r, l = n * h;
    return this.set(
      o * r + e,
      o * h - s * a,
      o * a + s * h,
      0,
      o * h + s * a,
      l * h + e,
      l * a - s * r,
      0,
      o * a - s * h,
      l * a + s * r,
      n * a * a + e,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(t, i, e) {
    return this.set(
      t,
      0,
      0,
      0,
      0,
      i,
      0,
      0,
      0,
      0,
      e,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeShear(t, i, e, s, n, r) {
    return this.set(
      1,
      e,
      n,
      0,
      t,
      1,
      r,
      0,
      i,
      s,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  compose(t, i, e) {
    const s = this.elements, n = i._x, r = i._y, h = i._z, a = i._w, o = n + n, l = r + r, c = h + h, u = n * o, d = n * l, m = n * c, y = r * l, x = r * c, g = h * c, w = a * o, b = a * l, M = a * c, S = e.x, F = e.y, _ = e.z;
    return s[0] = (1 - (y + g)) * S, s[1] = (d + M) * S, s[2] = (m - b) * S, s[3] = 0, s[4] = (d - M) * F, s[5] = (1 - (u + g)) * F, s[6] = (x + w) * F, s[7] = 0, s[8] = (m + b) * _, s[9] = (x - w) * _, s[10] = (1 - (u + y)) * _, s[11] = 0, s[12] = t.x, s[13] = t.y, s[14] = t.z, s[15] = 1, this;
  }
  decompose(t, i, e) {
    const s = this.elements;
    let n = Nt.set(s[0], s[1], s[2]).length();
    const r = Nt.set(s[4], s[5], s[6]).length(), h = Nt.set(s[8], s[9], s[10]).length();
    this.determinant() < 0 && (n = -n), t.x = s[12], t.y = s[13], t.z = s[14], tt.copy(this);
    const o = 1 / n, l = 1 / r, c = 1 / h;
    return tt.elements[0] *= o, tt.elements[1] *= o, tt.elements[2] *= o, tt.elements[4] *= l, tt.elements[5] *= l, tt.elements[6] *= l, tt.elements[8] *= c, tt.elements[9] *= c, tt.elements[10] *= c, i.setFromRotationMatrix(tt), e.x = n, e.y = r, e.z = h, this;
  }
  makePerspective(t, i, e, s, n, r, h = 2e3) {
    const a = this.elements, o = 2 * n / (i - t), l = 2 * n / (e - s), c = (i + t) / (i - t), u = (e + s) / (e - s);
    let d, m;
    if (h === 2e3)
      d = -(r + n) / (r - n), m = -2 * r * n / (r - n);
    else if (h === 2001)
      d = -r / (r - n), m = -r * n / (r - n);
    else
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + h);
    return a[0] = o, a[4] = 0, a[8] = c, a[12] = 0, a[1] = 0, a[5] = l, a[9] = u, a[13] = 0, a[2] = 0, a[6] = 0, a[10] = d, a[14] = m, a[3] = 0, a[7] = 0, a[11] = -1, a[15] = 0, this;
  }
  makeOrthographic(t, i, e, s, n, r, h = 2e3) {
    const a = this.elements, o = 1 / (i - t), l = 1 / (e - s), c = 1 / (r - n), u = (i + t) * o, d = (e + s) * l;
    let m, y;
    if (h === 2e3)
      m = (r + n) * c, y = -2 * c;
    else if (h === 2001)
      m = n * c, y = -1 * c;
    else
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + h);
    return a[0] = 2 * o, a[4] = 0, a[8] = 0, a[12] = -u, a[1] = 0, a[5] = 2 * l, a[9] = 0, a[13] = -d, a[2] = 0, a[6] = 0, a[10] = y, a[14] = -m, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, this;
  }
  equals(t) {
    const i = this.elements, e = t.elements;
    for (let s = 0; s < 16; s++)
      if (i[s] !== e[s]) return !1;
    return !0;
  }
  fromArray(t, i = 0) {
    for (let e = 0; e < 16; e++)
      this.elements[e] = t[e + i];
    return this;
  }
  toArray(t = [], i = 0) {
    const e = this.elements;
    return t[i] = e[0], t[i + 1] = e[1], t[i + 2] = e[2], t[i + 3] = e[3], t[i + 4] = e[4], t[i + 5] = e[5], t[i + 6] = e[6], t[i + 7] = e[7], t[i + 8] = e[8], t[i + 9] = e[9], t[i + 10] = e[10], t[i + 11] = e[11], t[i + 12] = e[12], t[i + 13] = e[13], t[i + 14] = e[14], t[i + 15] = e[15], t;
  }
}
const Nt = /* @__PURE__ */ new f(), tt = /* @__PURE__ */ new O(), ns = /* @__PURE__ */ new f(0, 0, 0), rs = /* @__PURE__ */ new f(1, 1, 1), St = /* @__PURE__ */ new f(), di = /* @__PURE__ */ new f(), X = /* @__PURE__ */ new f(), oe = /* @__PURE__ */ new O(), le = /* @__PURE__ */ new ni();
class ht {
  constructor(t = 0, i = 0, e = 0, s = ht.DEFAULT_ORDER) {
    this.isEuler = !0, this._x = t, this._y = i, this._z = e, this._order = s;
  }
  get x() {
    return this._x;
  }
  set x(t) {
    this._x = t, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(t) {
    this._y = t, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(t) {
    this._z = t, this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(t) {
    this._order = t, this._onChangeCallback();
  }
  set(t, i, e, s = this._order) {
    return this._x = t, this._y = i, this._z = e, this._order = s, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(t) {
    return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
  }
  setFromRotationMatrix(t, i = this._order, e = !0) {
    const s = t.elements, n = s[0], r = s[4], h = s[8], a = s[1], o = s[5], l = s[9], c = s[2], u = s[6], d = s[10];
    switch (i) {
      case "XYZ":
        this._y = Math.asin(T(h, -1, 1)), Math.abs(h) < 0.9999999 ? (this._x = Math.atan2(-l, d), this._z = Math.atan2(-r, n)) : (this._x = Math.atan2(u, o), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-T(l, -1, 1)), Math.abs(l) < 0.9999999 ? (this._y = Math.atan2(h, d), this._z = Math.atan2(a, o)) : (this._y = Math.atan2(-c, n), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(T(u, -1, 1)), Math.abs(u) < 0.9999999 ? (this._y = Math.atan2(-c, d), this._z = Math.atan2(-r, o)) : (this._y = 0, this._z = Math.atan2(a, n));
        break;
      case "ZYX":
        this._y = Math.asin(-T(c, -1, 1)), Math.abs(c) < 0.9999999 ? (this._x = Math.atan2(u, d), this._z = Math.atan2(a, n)) : (this._x = 0, this._z = Math.atan2(-r, o));
        break;
      case "YZX":
        this._z = Math.asin(T(a, -1, 1)), Math.abs(a) < 0.9999999 ? (this._x = Math.atan2(-l, o), this._y = Math.atan2(-c, n)) : (this._x = 0, this._y = Math.atan2(h, d));
        break;
      case "XZY":
        this._z = Math.asin(-T(r, -1, 1)), Math.abs(r) < 0.9999999 ? (this._x = Math.atan2(u, o), this._y = Math.atan2(h, n)) : (this._x = Math.atan2(-l, d), this._y = 0);
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + i);
    }
    return this._order = i, e === !0 && this._onChangeCallback(), this;
  }
  setFromQuaternion(t, i, e) {
    return oe.makeRotationFromQuaternion(t), this.setFromRotationMatrix(oe, i, e);
  }
  setFromVector3(t, i = this._order) {
    return this.set(t.x, t.y, t.z, i);
  }
  reorder(t) {
    return le.setFromEuler(this), this.setFromQuaternion(le, t);
  }
  equals(t) {
    return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
  }
  fromArray(t) {
    return this._x = t[0], this._y = t[1], this._z = t[2], t[3] !== void 0 && (this._order = t[3]), this._onChangeCallback(), this;
  }
  toArray(t = [], i = 0) {
    return t[i] = this._x, t[i + 1] = this._y, t[i + 2] = this._z, t[i + 3] = this._order, t;
  }
  _onChange(t) {
    return this._onChangeCallback = t, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
}
ht.DEFAULT_ORDER = "XYZ";
class as {
  constructor() {
    this.mask = 1;
  }
  set(t) {
    this.mask = (1 << t | 0) >>> 0;
  }
  enable(t) {
    this.mask |= 1 << t | 0;
  }
  enableAll() {
    this.mask = -1;
  }
  toggle(t) {
    this.mask ^= 1 << t | 0;
  }
  disable(t) {
    this.mask &= ~(1 << t | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(t) {
    return (this.mask & t.mask) !== 0;
  }
  isEnabled(t) {
    return (this.mask & (1 << t | 0)) !== 0;
  }
}
let hs = 0;
const ce = /* @__PURE__ */ new f(), Vt = /* @__PURE__ */ new ni(), ct = /* @__PURE__ */ new O(), mi = /* @__PURE__ */ new f(), $t = /* @__PURE__ */ new f(), os = /* @__PURE__ */ new f(), ls = /* @__PURE__ */ new ni(), ue = /* @__PURE__ */ new f(1, 0, 0), pe = /* @__PURE__ */ new f(0, 1, 0), de = /* @__PURE__ */ new f(0, 0, 1), me = { type: "added" }, cs = { type: "removed" }, Wt = { type: "childadded", child: null }, Di = { type: "childremoved", child: null };
class P extends si {
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: hs++ }), this.uuid = mt(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = P.DEFAULT_UP.clone();
    const t = new f(), i = new ht(), e = new ni(), s = new f(1, 1, 1);
    function n() {
      e.setFromEuler(i, !1);
    }
    function r() {
      i.setFromQuaternion(e, void 0, !1);
    }
    i._onChange(n), e._onChange(r), Object.defineProperties(this, {
      position: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: i
      },
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      scale: {
        configurable: !0,
        enumerable: !0,
        value: s
      },
      modelViewMatrix: {
        value: new O()
      },
      normalMatrix: {
        value: new xt()
      }
    }), this.matrix = new O(), this.matrixWorld = new O(), this.matrixAutoUpdate = P.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = P.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new as(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
  }
  onBeforeShadow() {
  }
  onAfterShadow() {
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(t) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(t) {
    return this.quaternion.premultiply(t), this;
  }
  setRotationFromAxisAngle(t, i) {
    this.quaternion.setFromAxisAngle(t, i);
  }
  setRotationFromEuler(t) {
    this.quaternion.setFromEuler(t, !0);
  }
  setRotationFromMatrix(t) {
    this.quaternion.setFromRotationMatrix(t);
  }
  setRotationFromQuaternion(t) {
    this.quaternion.copy(t);
  }
  rotateOnAxis(t, i) {
    return Vt.setFromAxisAngle(t, i), this.quaternion.multiply(Vt), this;
  }
  rotateOnWorldAxis(t, i) {
    return Vt.setFromAxisAngle(t, i), this.quaternion.premultiply(Vt), this;
  }
  rotateX(t) {
    return this.rotateOnAxis(ue, t);
  }
  rotateY(t) {
    return this.rotateOnAxis(pe, t);
  }
  rotateZ(t) {
    return this.rotateOnAxis(de, t);
  }
  translateOnAxis(t, i) {
    return ce.copy(t).applyQuaternion(this.quaternion), this.position.add(ce.multiplyScalar(i)), this;
  }
  translateX(t) {
    return this.translateOnAxis(ue, t);
  }
  translateY(t) {
    return this.translateOnAxis(pe, t);
  }
  translateZ(t) {
    return this.translateOnAxis(de, t);
  }
  localToWorld(t) {
    return this.updateWorldMatrix(!0, !1), t.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(t) {
    return this.updateWorldMatrix(!0, !1), t.applyMatrix4(ct.copy(this.matrixWorld).invert());
  }
  lookAt(t, i, e) {
    t.isVector3 ? mi.copy(t) : mi.set(t, i, e);
    const s = this.parent;
    this.updateWorldMatrix(!0, !1), $t.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? ct.lookAt($t, mi, this.up) : ct.lookAt(mi, $t, this.up), this.quaternion.setFromRotationMatrix(ct), s && (ct.extractRotation(s.matrixWorld), Vt.setFromRotationMatrix(ct), this.quaternion.premultiply(Vt.invert()));
  }
  add(t) {
    if (arguments.length > 1) {
      for (let i = 0; i < arguments.length; i++)
        this.add(arguments[i]);
      return this;
    }
    return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (t.removeFromParent(), t.parent = this, this.children.push(t), t.dispatchEvent(me), Wt.child = t, this.dispatchEvent(Wt), Wt.child = null) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
  }
  remove(t) {
    if (arguments.length > 1) {
      for (let e = 0; e < arguments.length; e++)
        this.remove(arguments[e]);
      return this;
    }
    const i = this.children.indexOf(t);
    return i !== -1 && (t.parent = null, this.children.splice(i, 1), t.dispatchEvent(cs), Di.child = t, this.dispatchEvent(Di), Di.child = null), this;
  }
  removeFromParent() {
    const t = this.parent;
    return t !== null && t.remove(this), this;
  }
  clear() {
    return this.remove(...this.children);
  }
  attach(t) {
    return this.updateWorldMatrix(!0, !1), ct.copy(this.matrixWorld).invert(), t.parent !== null && (t.parent.updateWorldMatrix(!0, !1), ct.multiply(t.parent.matrixWorld)), t.applyMatrix4(ct), t.removeFromParent(), t.parent = this, this.children.push(t), t.updateWorldMatrix(!1, !0), t.dispatchEvent(me), Wt.child = t, this.dispatchEvent(Wt), Wt.child = null, this;
  }
  getObjectById(t) {
    return this.getObjectByProperty("id", t);
  }
  getObjectByName(t) {
    return this.getObjectByProperty("name", t);
  }
  getObjectByProperty(t, i) {
    if (this[t] === i) return this;
    for (let e = 0, s = this.children.length; e < s; e++) {
      const r = this.children[e].getObjectByProperty(t, i);
      if (r !== void 0)
        return r;
    }
  }
  getObjectsByProperty(t, i, e = []) {
    this[t] === i && e.push(this);
    const s = this.children;
    for (let n = 0, r = s.length; n < r; n++)
      s[n].getObjectsByProperty(t, i, e);
    return e;
  }
  getWorldPosition(t) {
    return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(t) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($t, t, os), t;
  }
  getWorldScale(t) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($t, ls, t), t;
  }
  getWorldDirection(t) {
    this.updateWorldMatrix(!0, !1);
    const i = this.matrixWorld.elements;
    return t.set(i[8], i[9], i[10]).normalize();
  }
  raycast() {
  }
  traverse(t) {
    t(this);
    const i = this.children;
    for (let e = 0, s = i.length; e < s; e++)
      i[e].traverse(t);
  }
  traverseVisible(t) {
    if (this.visible === !1) return;
    t(this);
    const i = this.children;
    for (let e = 0, s = i.length; e < s; e++)
      i[e].traverseVisible(t);
  }
  traverseAncestors(t) {
    const i = this.parent;
    i !== null && (t(i), i.traverseAncestors(t));
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  updateMatrixWorld(t) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, t = !0);
    const i = this.children;
    for (let e = 0, s = i.length; e < s; e++)
      i[e].updateMatrixWorld(t);
  }
  updateWorldMatrix(t, i) {
    const e = this.parent;
    if (t === !0 && e !== null && e.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), i === !0) {
      const s = this.children;
      for (let n = 0, r = s.length; n < r; n++)
        s[n].updateWorldMatrix(!1, !0);
    }
  }
  toJSON(t) {
    const i = t === void 0 || typeof t == "string", e = {};
    i && (t = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, e.metadata = {
      version: 4.6,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const s = {};
    s.uuid = this.uuid, s.type = this.type, this.name !== "" && (s.name = this.name), this.castShadow === !0 && (s.castShadow = !0), this.receiveShadow === !0 && (s.receiveShadow = !0), this.visible === !1 && (s.visible = !1), this.frustumCulled === !1 && (s.frustumCulled = !1), this.renderOrder !== 0 && (s.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (s.userData = this.userData), s.layers = this.layers.mask, s.matrix = this.matrix.toArray(), s.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (s.matrixAutoUpdate = !1), this.isInstancedMesh && (s.type = "InstancedMesh", s.count = this.count, s.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (s.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (s.type = "BatchedMesh", s.perObjectFrustumCulled = this.perObjectFrustumCulled, s.sortObjects = this.sortObjects, s.drawRanges = this._drawRanges, s.reservedRanges = this._reservedRanges, s.visibility = this._visibility, s.active = this._active, s.bounds = this._bounds.map((h) => ({
      boxInitialized: h.boxInitialized,
      boxMin: h.box.min.toArray(),
      boxMax: h.box.max.toArray(),
      sphereInitialized: h.sphereInitialized,
      sphereRadius: h.sphere.radius,
      sphereCenter: h.sphere.center.toArray()
    })), s.maxInstanceCount = this._maxInstanceCount, s.maxVertexCount = this._maxVertexCount, s.maxIndexCount = this._maxIndexCount, s.geometryInitialized = this._geometryInitialized, s.geometryCount = this._geometryCount, s.matricesTexture = this._matricesTexture.toJSON(t), this._colorsTexture !== null && (s.colorsTexture = this._colorsTexture.toJSON(t)), this.boundingSphere !== null && (s.boundingSphere = {
      center: s.boundingSphere.center.toArray(),
      radius: s.boundingSphere.radius
    }), this.boundingBox !== null && (s.boundingBox = {
      min: s.boundingBox.min.toArray(),
      max: s.boundingBox.max.toArray()
    }));
    function n(h, a) {
      return h[a.uuid] === void 0 && (h[a.uuid] = a.toJSON(t)), a.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? s.background = this.background.toJSON() : this.background.isTexture && (s.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (s.environment = this.environment.toJSON(t).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      s.geometry = n(t.geometries, this.geometry);
      const h = this.geometry.parameters;
      if (h !== void 0 && h.shapes !== void 0) {
        const a = h.shapes;
        if (Array.isArray(a))
          for (let o = 0, l = a.length; o < l; o++) {
            const c = a[o];
            n(t.shapes, c);
          }
        else
          n(t.shapes, a);
      }
    }
    if (this.isSkinnedMesh && (s.bindMode = this.bindMode, s.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (n(t.skeletons, this.skeleton), s.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const h = [];
        for (let a = 0, o = this.material.length; a < o; a++)
          h.push(n(t.materials, this.material[a]));
        s.material = h;
      } else
        s.material = n(t.materials, this.material);
    if (this.children.length > 0) {
      s.children = [];
      for (let h = 0; h < this.children.length; h++)
        s.children.push(this.children[h].toJSON(t).object);
    }
    if (this.animations.length > 0) {
      s.animations = [];
      for (let h = 0; h < this.animations.length; h++) {
        const a = this.animations[h];
        s.animations.push(n(t.animations, a));
      }
    }
    if (i) {
      const h = r(t.geometries), a = r(t.materials), o = r(t.textures), l = r(t.images), c = r(t.shapes), u = r(t.skeletons), d = r(t.animations), m = r(t.nodes);
      h.length > 0 && (e.geometries = h), a.length > 0 && (e.materials = a), o.length > 0 && (e.textures = o), l.length > 0 && (e.images = l), c.length > 0 && (e.shapes = c), u.length > 0 && (e.skeletons = u), d.length > 0 && (e.animations = d), m.length > 0 && (e.nodes = m);
    }
    return e.object = s, e;
    function r(h) {
      const a = [];
      for (const o in h) {
        const l = h[o];
        delete l.metadata, a.push(l);
      }
      return a;
    }
  }
  clone(t) {
    return new this.constructor().copy(this, t);
  }
  copy(t, i = !0) {
    if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldAutoUpdate = t.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.animations = t.animations.slice(), this.userData = JSON.parse(JSON.stringify(t.userData)), i === !0)
      for (let e = 0; e < t.children.length; e++) {
        const s = t.children[e];
        this.add(s.clone());
      }
    return this;
  }
}
P.DEFAULT_UP = /* @__PURE__ */ new f(0, 1, 0);
P.DEFAULT_MATRIX_AUTO_UPDATE = !0;
P.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const it = /* @__PURE__ */ new f(), ut = /* @__PURE__ */ new f(), Pi = /* @__PURE__ */ new f(), pt = /* @__PURE__ */ new f(), Ut = /* @__PURE__ */ new f(), qt = /* @__PURE__ */ new f(), fe = /* @__PURE__ */ new f(), Li = /* @__PURE__ */ new f(), Oi = /* @__PURE__ */ new f(), Ni = /* @__PURE__ */ new f(), Vi = /* @__PURE__ */ new j(), Wi = /* @__PURE__ */ new j(), Ui = /* @__PURE__ */ new j();
class st {
  constructor(t = new f(), i = new f(), e = new f()) {
    this.a = t, this.b = i, this.c = e;
  }
  static getNormal(t, i, e, s) {
    s.subVectors(e, i), it.subVectors(t, i), s.cross(it);
    const n = s.lengthSq();
    return n > 0 ? s.multiplyScalar(1 / Math.sqrt(n)) : s.set(0, 0, 0);
  }
  // static/instance method to calculate barycentric coordinates
  // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
  static getBarycoord(t, i, e, s, n) {
    it.subVectors(s, i), ut.subVectors(e, i), Pi.subVectors(t, i);
    const r = it.dot(it), h = it.dot(ut), a = it.dot(Pi), o = ut.dot(ut), l = ut.dot(Pi), c = r * o - h * h;
    if (c === 0)
      return n.set(0, 0, 0), null;
    const u = 1 / c, d = (o * a - h * l) * u, m = (r * l - h * a) * u;
    return n.set(1 - d - m, m, d);
  }
  static containsPoint(t, i, e, s) {
    return this.getBarycoord(t, i, e, s, pt) === null ? !1 : pt.x >= 0 && pt.y >= 0 && pt.x + pt.y <= 1;
  }
  static getInterpolation(t, i, e, s, n, r, h, a) {
    return this.getBarycoord(t, i, e, s, pt) === null ? (a.x = 0, a.y = 0, "z" in a && (a.z = 0), "w" in a && (a.w = 0), null) : (a.setScalar(0), a.addScaledVector(n, pt.x), a.addScaledVector(r, pt.y), a.addScaledVector(h, pt.z), a);
  }
  static getInterpolatedAttribute(t, i, e, s, n, r) {
    return Vi.setScalar(0), Wi.setScalar(0), Ui.setScalar(0), Vi.fromBufferAttribute(t, i), Wi.fromBufferAttribute(t, e), Ui.fromBufferAttribute(t, s), r.setScalar(0), r.addScaledVector(Vi, n.x), r.addScaledVector(Wi, n.y), r.addScaledVector(Ui, n.z), r;
  }
  static isFrontFacing(t, i, e, s) {
    return it.subVectors(e, i), ut.subVectors(t, i), it.cross(ut).dot(s) < 0;
  }
  set(t, i, e) {
    return this.a.copy(t), this.b.copy(i), this.c.copy(e), this;
  }
  setFromPointsAndIndices(t, i, e, s) {
    return this.a.copy(t[i]), this.b.copy(t[e]), this.c.copy(t[s]), this;
  }
  setFromAttributeAndIndices(t, i, e, s) {
    return this.a.fromBufferAttribute(t, i), this.b.fromBufferAttribute(t, e), this.c.fromBufferAttribute(t, s), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
  }
  getArea() {
    return it.subVectors(this.c, this.b), ut.subVectors(this.a, this.b), it.cross(ut).length() * 0.5;
  }
  getMidpoint(t) {
    return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(t) {
    return st.getNormal(this.a, this.b, this.c, t);
  }
  getPlane(t) {
    return t.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(t, i) {
    return st.getBarycoord(t, this.a, this.b, this.c, i);
  }
  getInterpolation(t, i, e, s, n) {
    return st.getInterpolation(t, this.a, this.b, this.c, i, e, s, n);
  }
  containsPoint(t) {
    return st.containsPoint(t, this.a, this.b, this.c);
  }
  isFrontFacing(t) {
    return st.isFrontFacing(this.a, this.b, this.c, t);
  }
  intersectsBox(t) {
    return t.intersectsTriangle(this);
  }
  closestPointToPoint(t, i) {
    const e = this.a, s = this.b, n = this.c;
    let r, h;
    Ut.subVectors(s, e), qt.subVectors(n, e), Li.subVectors(t, e);
    const a = Ut.dot(Li), o = qt.dot(Li);
    if (a <= 0 && o <= 0)
      return i.copy(e);
    Oi.subVectors(t, s);
    const l = Ut.dot(Oi), c = qt.dot(Oi);
    if (l >= 0 && c <= l)
      return i.copy(s);
    const u = a * c - l * o;
    if (u <= 0 && a >= 0 && l <= 0)
      return r = a / (a - l), i.copy(e).addScaledVector(Ut, r);
    Ni.subVectors(t, n);
    const d = Ut.dot(Ni), m = qt.dot(Ni);
    if (m >= 0 && d <= m)
      return i.copy(n);
    const y = d * o - a * m;
    if (y <= 0 && o >= 0 && m <= 0)
      return h = o / (o - m), i.copy(e).addScaledVector(qt, h);
    const x = l * m - d * c;
    if (x <= 0 && c - l >= 0 && d - m >= 0)
      return fe.subVectors(n, s), h = (c - l) / (c - l + (d - m)), i.copy(s).addScaledVector(fe, h);
    const g = 1 / (x + y + u);
    return r = y * g, h = u * g, i.copy(e).addScaledVector(Ut, r).addScaledVector(qt, h);
  }
  equals(t) {
    return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
  }
}
const Te = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, _t = { h: 0, s: 0, l: 0 }, fi = { h: 0, s: 0, l: 0 };
function qi(p, t, i) {
  return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? p + (t - p) * 6 * i : i < 1 / 2 ? t : i < 2 / 3 ? p + (t - p) * 6 * (2 / 3 - i) : p;
}
class B {
  constructor(t, i, e) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(t, i, e);
  }
  set(t, i, e) {
    if (i === void 0 && e === void 0) {
      const s = t;
      s && s.isColor ? this.copy(s) : typeof s == "number" ? this.setHex(s) : typeof s == "string" && this.setStyle(s);
    } else
      this.setRGB(t, i, e);
    return this;
  }
  setScalar(t) {
    return this.r = t, this.g = t, this.b = t, this;
  }
  setHex(t, i = et) {
    return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (t & 255) / 255, Q.toWorkingColorSpace(this, i), this;
  }
  setRGB(t, i, e, s = Q.workingColorSpace) {
    return this.r = t, this.g = i, this.b = e, Q.toWorkingColorSpace(this, s), this;
  }
  setHSL(t, i, e, s = Q.workingColorSpace) {
    if (t = Ji(t, 1), i = T(i, 0, 1), e = T(e, 0, 1), i === 0)
      this.r = this.g = this.b = e;
    else {
      const n = e <= 0.5 ? e * (1 + i) : e + i - e * i, r = 2 * e - n;
      this.r = qi(r, n, t + 1 / 3), this.g = qi(r, n, t), this.b = qi(r, n, t - 1 / 3);
    }
    return Q.toWorkingColorSpace(this, s), this;
  }
  setStyle(t, i = et) {
    function e(n) {
      n !== void 0 && parseFloat(n) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
    }
    let s;
    if (s = /^(\w+)\(([^\)]*)\)/.exec(t)) {
      let n;
      const r = s[1], h = s[2];
      switch (r) {
        case "rgb":
        case "rgba":
          if (n = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(h))
            return e(n[4]), this.setRGB(
              Math.min(255, parseInt(n[1], 10)) / 255,
              Math.min(255, parseInt(n[2], 10)) / 255,
              Math.min(255, parseInt(n[3], 10)) / 255,
              i
            );
          if (n = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(h))
            return e(n[4]), this.setRGB(
              Math.min(100, parseInt(n[1], 10)) / 100,
              Math.min(100, parseInt(n[2], 10)) / 100,
              Math.min(100, parseInt(n[3], 10)) / 100,
              i
            );
          break;
        case "hsl":
        case "hsla":
          if (n = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(h))
            return e(n[4]), this.setHSL(
              parseFloat(n[1]) / 360,
              parseFloat(n[2]) / 100,
              parseFloat(n[3]) / 100,
              i
            );
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + t);
      }
    } else if (s = /^\#([A-Fa-f\d]+)$/.exec(t)) {
      const n = s[1], r = n.length;
      if (r === 3)
        return this.setRGB(
          parseInt(n.charAt(0), 16) / 15,
          parseInt(n.charAt(1), 16) / 15,
          parseInt(n.charAt(2), 16) / 15,
          i
        );
      if (r === 6)
        return this.setHex(parseInt(n, 16), i);
      console.warn("THREE.Color: Invalid hex color " + t);
    } else if (t && t.length > 0)
      return this.setColorName(t, i);
    return this;
  }
  setColorName(t, i = et) {
    const e = Te[t.toLowerCase()];
    return e !== void 0 ? this.setHex(e, i) : console.warn("THREE.Color: Unknown color " + t), this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(t) {
    return this.r = t.r, this.g = t.g, this.b = t.b, this;
  }
  copySRGBToLinear(t) {
    return this.r = ft(t.r), this.g = ft(t.g), this.b = ft(t.b), this;
  }
  copyLinearToSRGB(t) {
    return this.r = Yt(t.r), this.g = Yt(t.g), this.b = Yt(t.b), this;
  }
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  getHex(t = et) {
    return Q.fromWorkingColorSpace(W.copy(this), t), Math.round(T(W.r * 255, 0, 255)) * 65536 + Math.round(T(W.g * 255, 0, 255)) * 256 + Math.round(T(W.b * 255, 0, 255));
  }
  getHexString(t = et) {
    return ("000000" + this.getHex(t).toString(16)).slice(-6);
  }
  getHSL(t, i = Q.workingColorSpace) {
    Q.fromWorkingColorSpace(W.copy(this), i);
    const e = W.r, s = W.g, n = W.b, r = Math.max(e, s, n), h = Math.min(e, s, n);
    let a, o;
    const l = (h + r) / 2;
    if (h === r)
      a = 0, o = 0;
    else {
      const c = r - h;
      switch (o = l <= 0.5 ? c / (r + h) : c / (2 - r - h), r) {
        case e:
          a = (s - n) / c + (s < n ? 6 : 0);
          break;
        case s:
          a = (n - e) / c + 2;
          break;
        case n:
          a = (e - s) / c + 4;
          break;
      }
      a /= 6;
    }
    return t.h = a, t.s = o, t.l = l, t;
  }
  getRGB(t, i = Q.workingColorSpace) {
    return Q.fromWorkingColorSpace(W.copy(this), i), t.r = W.r, t.g = W.g, t.b = W.b, t;
  }
  getStyle(t = et) {
    Q.fromWorkingColorSpace(W.copy(this), t);
    const i = W.r, e = W.g, s = W.b;
    return t !== et ? `color(${t} ${i.toFixed(3)} ${e.toFixed(3)} ${s.toFixed(3)})` : `rgb(${Math.round(i * 255)},${Math.round(e * 255)},${Math.round(s * 255)})`;
  }
  offsetHSL(t, i, e) {
    return this.getHSL(_t), this.setHSL(_t.h + t, _t.s + i, _t.l + e);
  }
  add(t) {
    return this.r += t.r, this.g += t.g, this.b += t.b, this;
  }
  addColors(t, i) {
    return this.r = t.r + i.r, this.g = t.g + i.g, this.b = t.b + i.b, this;
  }
  addScalar(t) {
    return this.r += t, this.g += t, this.b += t, this;
  }
  sub(t) {
    return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
  }
  multiply(t) {
    return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
  }
  multiplyScalar(t) {
    return this.r *= t, this.g *= t, this.b *= t, this;
  }
  lerp(t, i) {
    return this.r += (t.r - this.r) * i, this.g += (t.g - this.g) * i, this.b += (t.b - this.b) * i, this;
  }
  lerpColors(t, i, e) {
    return this.r = t.r + (i.r - t.r) * e, this.g = t.g + (i.g - t.g) * e, this.b = t.b + (i.b - t.b) * e, this;
  }
  lerpHSL(t, i) {
    this.getHSL(_t), t.getHSL(fi);
    const e = ii(_t.h, fi.h, i), s = ii(_t.s, fi.s, i), n = ii(_t.l, fi.l, i);
    return this.setHSL(e, s, n), this;
  }
  setFromVector3(t) {
    return this.r = t.x, this.g = t.y, this.b = t.z, this;
  }
  applyMatrix3(t) {
    const i = this.r, e = this.g, s = this.b, n = t.elements;
    return this.r = n[0] * i + n[3] * e + n[6] * s, this.g = n[1] * i + n[4] * e + n[7] * s, this.b = n[2] * i + n[5] * e + n[8] * s, this;
  }
  equals(t) {
    return t.r === this.r && t.g === this.g && t.b === this.b;
  }
  fromArray(t, i = 0) {
    return this.r = t[i], this.g = t[i + 1], this.b = t[i + 2], this;
  }
  toArray(t = [], i = 0) {
    return t[i] = this.r, t[i + 1] = this.g, t[i + 2] = this.b, t;
  }
  fromBufferAttribute(t, i) {
    return this.r = t.getX(i), this.g = t.getY(i), this.b = t.getZ(i), this;
  }
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
const W = /* @__PURE__ */ new B();
B.NAMES = Te;
let us = 0;
class $ extends si {
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: us++ }), this.uuid = mt(), this.name = "", this.type = "Material", this.blending = 1, this.side = 0, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = 204, this.blendDst = 205, this.blendEquation = 100, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new B(0, 0, 0), this.blendAlpha = 0, this.depthFunc = 3, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = 7680, this.stencilZFail = 7680, this.stencilZPass = 7680, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(t) {
    this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
  }
  // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
  onBeforeRender() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(t) {
    if (t !== void 0)
      for (const i in t) {
        const e = t[i];
        if (e === void 0) {
          console.warn(`THREE.Material: parameter '${i}' has value of undefined.`);
          continue;
        }
        const s = this[i];
        if (s === void 0) {
          console.warn(`THREE.Material: '${i}' is not a property of THREE.${this.type}.`);
          continue;
        }
        s && s.isColor ? s.set(e) : s && s.isVector3 && e && e.isVector3 ? s.copy(e) : this[i] = e;
      }
  }
  toJSON(t) {
    const i = t === void 0 || typeof t == "string";
    i && (t = {
      textures: {},
      images: {}
    });
    const e = {
      metadata: {
        version: 4.6,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), this.color && this.color.isColor && (e.color = this.color.getHex()), this.roughness !== void 0 && (e.roughness = this.roughness), this.metalness !== void 0 && (e.metalness = this.metalness), this.sheen !== void 0 && (e.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (e.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (e.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (e.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (e.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (e.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (e.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (e.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (e.shininess = this.shininess), this.clearcoat !== void 0 && (e.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (e.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (e.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (e.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (e.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, e.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.dispersion !== void 0 && (e.dispersion = this.dispersion), this.iridescence !== void 0 && (e.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (e.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (e.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (e.iridescenceMap = this.iridescenceMap.toJSON(t).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (e.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t).uuid), this.anisotropy !== void 0 && (e.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (e.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (e.anisotropyMap = this.anisotropyMap.toJSON(t).uuid), this.map && this.map.isTexture && (e.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (e.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (e.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (e.lightMap = this.lightMap.toJSON(t).uuid, e.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (e.aoMap = this.aoMap.toJSON(t).uuid, e.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (e.bumpMap = this.bumpMap.toJSON(t).uuid, e.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (e.normalMap = this.normalMap.toJSON(t).uuid, e.normalMapType = this.normalMapType, e.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (e.displacementMap = this.displacementMap.toJSON(t).uuid, e.displacementScale = this.displacementScale, e.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (e.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (e.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (e.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (e.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (e.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (e.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (e.envMap = this.envMap.toJSON(t).uuid, this.combine !== void 0 && (e.combine = this.combine)), this.envMapRotation !== void 0 && (e.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (e.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (e.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (e.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (e.gradientMap = this.gradientMap.toJSON(t).uuid), this.transmission !== void 0 && (e.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (e.transmissionMap = this.transmissionMap.toJSON(t).uuid), this.thickness !== void 0 && (e.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (e.thicknessMap = this.thicknessMap.toJSON(t).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (e.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (e.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (e.size = this.size), this.shadowSide !== null && (e.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (e.sizeAttenuation = this.sizeAttenuation), this.blending !== 1 && (e.blending = this.blending), this.side !== 0 && (e.side = this.side), this.vertexColors === !0 && (e.vertexColors = !0), this.opacity < 1 && (e.opacity = this.opacity), this.transparent === !0 && (e.transparent = !0), this.blendSrc !== 204 && (e.blendSrc = this.blendSrc), this.blendDst !== 205 && (e.blendDst = this.blendDst), this.blendEquation !== 100 && (e.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (e.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (e.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (e.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (e.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (e.blendAlpha = this.blendAlpha), this.depthFunc !== 3 && (e.depthFunc = this.depthFunc), this.depthTest === !1 && (e.depthTest = this.depthTest), this.depthWrite === !1 && (e.depthWrite = this.depthWrite), this.colorWrite === !1 && (e.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (e.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== 519 && (e.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (e.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (e.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== 7680 && (e.stencilFail = this.stencilFail), this.stencilZFail !== 7680 && (e.stencilZFail = this.stencilZFail), this.stencilZPass !== 7680 && (e.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (e.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (e.rotation = this.rotation), this.polygonOffset === !0 && (e.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (e.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (e.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (e.linewidth = this.linewidth), this.dashSize !== void 0 && (e.dashSize = this.dashSize), this.gapSize !== void 0 && (e.gapSize = this.gapSize), this.scale !== void 0 && (e.scale = this.scale), this.dithering === !0 && (e.dithering = !0), this.alphaTest > 0 && (e.alphaTest = this.alphaTest), this.alphaHash === !0 && (e.alphaHash = !0), this.alphaToCoverage === !0 && (e.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (e.premultipliedAlpha = !0), this.forceSinglePass === !0 && (e.forceSinglePass = !0), this.wireframe === !0 && (e.wireframe = !0), this.wireframeLinewidth > 1 && (e.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (e.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (e.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (e.flatShading = !0), this.visible === !1 && (e.visible = !1), this.toneMapped === !1 && (e.toneMapped = !1), this.fog === !1 && (e.fog = !1), Object.keys(this.userData).length > 0 && (e.userData = this.userData);
    function s(n) {
      const r = [];
      for (const h in n) {
        const a = n[h];
        delete a.metadata, r.push(a);
      }
      return r;
    }
    if (i) {
      const n = s(t.textures), r = s(t.images);
      n.length > 0 && (e.textures = n), r.length > 0 && (e.images = r);
    }
    return e;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    this.name = t.name, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.blendColor.copy(t.blendColor), this.blendAlpha = t.blendAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
    const i = t.clippingPlanes;
    let e = null;
    if (i !== null) {
      const s = i.length;
      e = new Array(s);
      for (let n = 0; n !== s; ++n)
        e[n] = i[n].clone();
    }
    return this.clippingPlanes = e, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaHash = t.alphaHash, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.forceSinglePass = t.forceSinglePass, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  onBuild() {
    console.warn("Material: onBuild() has been removed.");
  }
}
class ps extends $ {
  constructor(t) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new B(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new ht(), this.combine = 0, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
  }
}
const dt = /* @__PURE__ */ ds();
function ds() {
  const p = new ArrayBuffer(4), t = new Float32Array(p), i = new Uint32Array(p), e = new Uint32Array(512), s = new Uint32Array(512);
  for (let a = 0; a < 256; ++a) {
    const o = a - 127;
    o < -27 ? (e[a] = 0, e[a | 256] = 32768, s[a] = 24, s[a | 256] = 24) : o < -14 ? (e[a] = 1024 >> -o - 14, e[a | 256] = 1024 >> -o - 14 | 32768, s[a] = -o - 1, s[a | 256] = -o - 1) : o <= 15 ? (e[a] = o + 15 << 10, e[a | 256] = o + 15 << 10 | 32768, s[a] = 13, s[a | 256] = 13) : o < 128 ? (e[a] = 31744, e[a | 256] = 64512, s[a] = 24, s[a | 256] = 24) : (e[a] = 31744, e[a | 256] = 64512, s[a] = 13, s[a | 256] = 13);
  }
  const n = new Uint32Array(2048), r = new Uint32Array(64), h = new Uint32Array(64);
  for (let a = 1; a < 1024; ++a) {
    let o = a << 13, l = 0;
    for (; !(o & 8388608); )
      o <<= 1, l -= 8388608;
    o &= -8388609, l += 947912704, n[a] = o | l;
  }
  for (let a = 1024; a < 2048; ++a)
    n[a] = 939524096 + (a - 1024 << 13);
  for (let a = 1; a < 31; ++a)
    r[a] = a << 23;
  r[31] = 1199570944, r[32] = 2147483648;
  for (let a = 33; a < 63; ++a)
    r[a] = 2147483648 + (a - 32 << 23);
  r[63] = 3347054592;
  for (let a = 1; a < 64; ++a)
    a !== 32 && (h[a] = 1024);
  return {
    floatView: t,
    uint32View: i,
    baseTable: e,
    shiftTable: s,
    mantissaTable: n,
    exponentTable: r,
    offsetTable: h
  };
}
function H(p) {
  Math.abs(p) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), p = T(p, -65504, 65504), dt.floatView[0] = p;
  const t = dt.uint32View[0], i = t >> 23 & 511;
  return dt.baseTable[i] + ((t & 8388607) >> dt.shiftTable[i]);
}
function yi(p) {
  const t = p >> 10;
  return dt.uint32View[0] = dt.mantissaTable[dt.offsetTable[t] + (p & 1023)] + dt.exponentTable[t], dt.floatView[0];
}
const v = /* @__PURE__ */ new f(), xi = /* @__PURE__ */ new C();
class yt {
  constructor(t, i, e = !1) {
    if (Array.isArray(t))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, this.name = "", this.array = t, this.itemSize = i, this.count = t !== void 0 ? t.length / i : 0, this.normalized = e, this.usage = 35044, this.updateRanges = [], this.gpuType = 1015, this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  setUsage(t) {
    return this.usage = t, this;
  }
  addUpdateRange(t, i) {
    this.updateRanges.push({ start: t, count: i });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(t) {
    return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this.gpuType = t.gpuType, this;
  }
  copyAt(t, i, e) {
    t *= this.itemSize, e *= i.itemSize;
    for (let s = 0, n = this.itemSize; s < n; s++)
      this.array[t + s] = i.array[e + s];
    return this;
  }
  copyArray(t) {
    return this.array.set(t), this;
  }
  applyMatrix3(t) {
    if (this.itemSize === 2)
      for (let i = 0, e = this.count; i < e; i++)
        xi.fromBufferAttribute(this, i), xi.applyMatrix3(t), this.setXY(i, xi.x, xi.y);
    else if (this.itemSize === 3)
      for (let i = 0, e = this.count; i < e; i++)
        v.fromBufferAttribute(this, i), v.applyMatrix3(t), this.setXYZ(i, v.x, v.y, v.z);
    return this;
  }
  applyMatrix4(t) {
    for (let i = 0, e = this.count; i < e; i++)
      v.fromBufferAttribute(this, i), v.applyMatrix4(t), this.setXYZ(i, v.x, v.y, v.z);
    return this;
  }
  applyNormalMatrix(t) {
    for (let i = 0, e = this.count; i < e; i++)
      v.fromBufferAttribute(this, i), v.applyNormalMatrix(t), this.setXYZ(i, v.x, v.y, v.z);
    return this;
  }
  transformDirection(t) {
    for (let i = 0, e = this.count; i < e; i++)
      v.fromBufferAttribute(this, i), v.transformDirection(t), this.setXYZ(i, v.x, v.y, v.z);
    return this;
  }
  set(t, i = 0) {
    return this.array.set(t, i), this;
  }
  getComponent(t, i) {
    let e = this.array[t * this.itemSize + i];
    return this.normalized && (e = q(e, this.array)), e;
  }
  setComponent(t, i, e) {
    return this.normalized && (e = z(e, this.array)), this.array[t * this.itemSize + i] = e, this;
  }
  getX(t) {
    let i = this.array[t * this.itemSize];
    return this.normalized && (i = q(i, this.array)), i;
  }
  setX(t, i) {
    return this.normalized && (i = z(i, this.array)), this.array[t * this.itemSize] = i, this;
  }
  getY(t) {
    let i = this.array[t * this.itemSize + 1];
    return this.normalized && (i = q(i, this.array)), i;
  }
  setY(t, i) {
    return this.normalized && (i = z(i, this.array)), this.array[t * this.itemSize + 1] = i, this;
  }
  getZ(t) {
    let i = this.array[t * this.itemSize + 2];
    return this.normalized && (i = q(i, this.array)), i;
  }
  setZ(t, i) {
    return this.normalized && (i = z(i, this.array)), this.array[t * this.itemSize + 2] = i, this;
  }
  getW(t) {
    let i = this.array[t * this.itemSize + 3];
    return this.normalized && (i = q(i, this.array)), i;
  }
  setW(t, i) {
    return this.normalized && (i = z(i, this.array)), this.array[t * this.itemSize + 3] = i, this;
  }
  setXY(t, i, e) {
    return t *= this.itemSize, this.normalized && (i = z(i, this.array), e = z(e, this.array)), this.array[t + 0] = i, this.array[t + 1] = e, this;
  }
  setXYZ(t, i, e, s) {
    return t *= this.itemSize, this.normalized && (i = z(i, this.array), e = z(e, this.array), s = z(s, this.array)), this.array[t + 0] = i, this.array[t + 1] = e, this.array[t + 2] = s, this;
  }
  setXYZW(t, i, e, s, n) {
    return t *= this.itemSize, this.normalized && (i = z(i, this.array), e = z(e, this.array), s = z(s, this.array), n = z(n, this.array)), this.array[t + 0] = i, this.array[t + 1] = e, this.array[t + 2] = s, this.array[t + 3] = n, this;
  }
  onUpload(t) {
    return this.onUploadCallback = t, this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const t = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (t.name = this.name), this.usage !== 35044 && (t.usage = this.usage), t;
  }
}
class ms extends yt {
  constructor(t, i, e) {
    super(new Uint16Array(t), i, e);
  }
}
class fs extends yt {
  constructor(t, i, e) {
    super(new Uint32Array(t), i, e);
  }
}
class Ba extends yt {
  constructor(t, i, e) {
    super(new Uint16Array(t), i, e), this.isFloat16BufferAttribute = !0;
  }
  getX(t) {
    let i = yi(this.array[t * this.itemSize]);
    return this.normalized && (i = q(i, this.array)), i;
  }
  setX(t, i) {
    return this.normalized && (i = z(i, this.array)), this.array[t * this.itemSize] = H(i), this;
  }
  getY(t) {
    let i = yi(this.array[t * this.itemSize + 1]);
    return this.normalized && (i = q(i, this.array)), i;
  }
  setY(t, i) {
    return this.normalized && (i = z(i, this.array)), this.array[t * this.itemSize + 1] = H(i), this;
  }
  getZ(t) {
    let i = yi(this.array[t * this.itemSize + 2]);
    return this.normalized && (i = q(i, this.array)), i;
  }
  setZ(t, i) {
    return this.normalized && (i = z(i, this.array)), this.array[t * this.itemSize + 2] = H(i), this;
  }
  getW(t) {
    let i = yi(this.array[t * this.itemSize + 3]);
    return this.normalized && (i = q(i, this.array)), i;
  }
  setW(t, i) {
    return this.normalized && (i = z(i, this.array)), this.array[t * this.itemSize + 3] = H(i), this;
  }
  setXY(t, i, e) {
    return t *= this.itemSize, this.normalized && (i = z(i, this.array), e = z(e, this.array)), this.array[t + 0] = H(i), this.array[t + 1] = H(e), this;
  }
  setXYZ(t, i, e, s) {
    return t *= this.itemSize, this.normalized && (i = z(i, this.array), e = z(e, this.array), s = z(s, this.array)), this.array[t + 0] = H(i), this.array[t + 1] = H(e), this.array[t + 2] = H(s), this;
  }
  setXYZW(t, i, e, s, n) {
    return t *= this.itemSize, this.normalized && (i = z(i, this.array), e = z(e, this.array), s = z(s, this.array), n = z(n, this.array)), this.array[t + 0] = H(i), this.array[t + 1] = H(e), this.array[t + 2] = H(s), this.array[t + 3] = H(n), this;
  }
}
class Rt extends yt {
  constructor(t, i, e) {
    super(new Float32Array(t), i, e);
  }
}
let ys = 0;
const J = /* @__PURE__ */ new O(), ji = /* @__PURE__ */ new P(), jt = /* @__PURE__ */ new f(), Y = /* @__PURE__ */ new ri(), Qt = /* @__PURE__ */ new ri(), D = /* @__PURE__ */ new f();
class ai extends si {
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: ys++ }), this.uuid = mt(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(t) {
    return Array.isArray(t) ? this.index = new (Ze(t) ? fs : ms)(t, 1) : this.index = t, this;
  }
  setIndirect(t) {
    return this.indirect = t, this;
  }
  getIndirect() {
    return this.indirect;
  }
  getAttribute(t) {
    return this.attributes[t];
  }
  setAttribute(t, i) {
    return this.attributes[t] = i, this;
  }
  deleteAttribute(t) {
    return delete this.attributes[t], this;
  }
  hasAttribute(t) {
    return this.attributes[t] !== void 0;
  }
  addGroup(t, i, e = 0) {
    this.groups.push({
      start: t,
      count: i,
      materialIndex: e
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(t, i) {
    this.drawRange.start = t, this.drawRange.count = i;
  }
  applyMatrix4(t) {
    const i = this.attributes.position;
    i !== void 0 && (i.applyMatrix4(t), i.needsUpdate = !0);
    const e = this.attributes.normal;
    if (e !== void 0) {
      const n = new xt().getNormalMatrix(t);
      e.applyNormalMatrix(n), e.needsUpdate = !0;
    }
    const s = this.attributes.tangent;
    return s !== void 0 && (s.transformDirection(t), s.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  applyQuaternion(t) {
    return J.makeRotationFromQuaternion(t), this.applyMatrix4(J), this;
  }
  rotateX(t) {
    return J.makeRotationX(t), this.applyMatrix4(J), this;
  }
  rotateY(t) {
    return J.makeRotationY(t), this.applyMatrix4(J), this;
  }
  rotateZ(t) {
    return J.makeRotationZ(t), this.applyMatrix4(J), this;
  }
  translate(t, i, e) {
    return J.makeTranslation(t, i, e), this.applyMatrix4(J), this;
  }
  scale(t, i, e) {
    return J.makeScale(t, i, e), this.applyMatrix4(J), this;
  }
  lookAt(t) {
    return ji.lookAt(t), ji.updateMatrix(), this.applyMatrix4(ji.matrix), this;
  }
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(jt).negate(), this.translate(jt.x, jt.y, jt.z), this;
  }
  setFromPoints(t) {
    const i = this.getAttribute("position");
    if (i === void 0) {
      const e = [];
      for (let s = 0, n = t.length; s < n; s++) {
        const r = t[s];
        e.push(r.x, r.y, r.z || 0);
      }
      this.setAttribute("position", new Rt(e, 3));
    } else {
      const e = Math.min(t.length, i.count);
      for (let s = 0; s < e; s++) {
        const n = t[s];
        i.setXYZ(s, n.x, n.y, n.z || 0);
      }
      t.length > i.count && console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), i.needsUpdate = !0;
    }
    return this;
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new ri());
    const t = this.attributes.position, i = this.morphAttributes.position;
    if (t && t.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(
        new f(-1 / 0, -1 / 0, -1 / 0),
        new f(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (t !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(t), i)
        for (let e = 0, s = i.length; e < s; e++) {
          const n = i[e];
          Y.setFromBufferAttribute(n), this.morphTargetsRelative ? (D.addVectors(this.boundingBox.min, Y.min), this.boundingBox.expandByPoint(D), D.addVectors(this.boundingBox.max, Y.max), this.boundingBox.expandByPoint(D)) : (this.boundingBox.expandByPoint(Y.min), this.boundingBox.expandByPoint(Y.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new $i());
    const t = this.attributes.position, i = this.morphAttributes.position;
    if (t && t.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new f(), 1 / 0);
      return;
    }
    if (t) {
      const e = this.boundingSphere.center;
      if (Y.setFromBufferAttribute(t), i)
        for (let n = 0, r = i.length; n < r; n++) {
          const h = i[n];
          Qt.setFromBufferAttribute(h), this.morphTargetsRelative ? (D.addVectors(Y.min, Qt.min), Y.expandByPoint(D), D.addVectors(Y.max, Qt.max), Y.expandByPoint(D)) : (Y.expandByPoint(Qt.min), Y.expandByPoint(Qt.max));
        }
      Y.getCenter(e);
      let s = 0;
      for (let n = 0, r = t.count; n < r; n++)
        D.fromBufferAttribute(t, n), s = Math.max(s, e.distanceToSquared(D));
      if (i)
        for (let n = 0, r = i.length; n < r; n++) {
          const h = i[n], a = this.morphTargetsRelative;
          for (let o = 0, l = h.count; o < l; o++)
            D.fromBufferAttribute(h, o), a && (jt.fromBufferAttribute(t, o), D.add(jt)), s = Math.max(s, e.distanceToSquared(D));
        }
      this.boundingSphere.radius = Math.sqrt(s), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeTangents() {
    const t = this.index, i = this.attributes;
    if (t === null || i.position === void 0 || i.normal === void 0 || i.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const e = i.position, s = i.normal, n = i.uv;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new yt(new Float32Array(4 * e.count), 4));
    const r = this.getAttribute("tangent"), h = [], a = [];
    for (let A = 0; A < e.count; A++)
      h[A] = new f(), a[A] = new f();
    const o = new f(), l = new f(), c = new f(), u = new C(), d = new C(), m = new C(), y = new f(), x = new f();
    function g(A, R, E) {
      o.fromBufferAttribute(e, A), l.fromBufferAttribute(e, R), c.fromBufferAttribute(e, E), u.fromBufferAttribute(n, A), d.fromBufferAttribute(n, R), m.fromBufferAttribute(n, E), l.sub(o), c.sub(o), d.sub(u), m.sub(u);
      const k = 1 / (d.x * m.y - m.x * d.y);
      isFinite(k) && (y.copy(l).multiplyScalar(m.y).addScaledVector(c, -d.y).multiplyScalar(k), x.copy(c).multiplyScalar(d.x).addScaledVector(l, -m.x).multiplyScalar(k), h[A].add(y), h[R].add(y), h[E].add(y), a[A].add(x), a[R].add(x), a[E].add(x));
    }
    let w = this.groups;
    w.length === 0 && (w = [{
      start: 0,
      count: t.count
    }]);
    for (let A = 0, R = w.length; A < R; ++A) {
      const E = w[A], k = E.start, nt = E.count;
      for (let I = k, rt = k + nt; I < rt; I += 3)
        g(
          t.getX(I + 0),
          t.getX(I + 1),
          t.getX(I + 2)
        );
    }
    const b = new f(), M = new f(), S = new f(), F = new f();
    function _(A) {
      S.fromBufferAttribute(s, A), F.copy(S);
      const R = h[A];
      b.copy(R), b.sub(S.multiplyScalar(S.dot(R))).normalize(), M.crossVectors(F, R);
      const k = M.dot(a[A]) < 0 ? -1 : 1;
      r.setXYZW(A, b.x, b.y, b.z, k);
    }
    for (let A = 0, R = w.length; A < R; ++A) {
      const E = w[A], k = E.start, nt = E.count;
      for (let I = k, rt = k + nt; I < rt; I += 3)
        _(t.getX(I + 0)), _(t.getX(I + 1)), _(t.getX(I + 2));
    }
  }
  computeVertexNormals() {
    const t = this.index, i = this.getAttribute("position");
    if (i !== void 0) {
      let e = this.getAttribute("normal");
      if (e === void 0)
        e = new yt(new Float32Array(i.count * 3), 3), this.setAttribute("normal", e);
      else
        for (let u = 0, d = e.count; u < d; u++)
          e.setXYZ(u, 0, 0, 0);
      const s = new f(), n = new f(), r = new f(), h = new f(), a = new f(), o = new f(), l = new f(), c = new f();
      if (t)
        for (let u = 0, d = t.count; u < d; u += 3) {
          const m = t.getX(u + 0), y = t.getX(u + 1), x = t.getX(u + 2);
          s.fromBufferAttribute(i, m), n.fromBufferAttribute(i, y), r.fromBufferAttribute(i, x), l.subVectors(r, n), c.subVectors(s, n), l.cross(c), h.fromBufferAttribute(e, m), a.fromBufferAttribute(e, y), o.fromBufferAttribute(e, x), h.add(l), a.add(l), o.add(l), e.setXYZ(m, h.x, h.y, h.z), e.setXYZ(y, a.x, a.y, a.z), e.setXYZ(x, o.x, o.y, o.z);
        }
      else
        for (let u = 0, d = i.count; u < d; u += 3)
          s.fromBufferAttribute(i, u + 0), n.fromBufferAttribute(i, u + 1), r.fromBufferAttribute(i, u + 2), l.subVectors(r, n), c.subVectors(s, n), l.cross(c), e.setXYZ(u + 0, l.x, l.y, l.z), e.setXYZ(u + 1, l.x, l.y, l.z), e.setXYZ(u + 2, l.x, l.y, l.z);
      this.normalizeNormals(), e.needsUpdate = !0;
    }
  }
  normalizeNormals() {
    const t = this.attributes.normal;
    for (let i = 0, e = t.count; i < e; i++)
      D.fromBufferAttribute(t, i), D.normalize(), t.setXYZ(i, D.x, D.y, D.z);
  }
  toNonIndexed() {
    function t(h, a) {
      const o = h.array, l = h.itemSize, c = h.normalized, u = new o.constructor(a.length * l);
      let d = 0, m = 0;
      for (let y = 0, x = a.length; y < x; y++) {
        h.isInterleavedBufferAttribute ? d = a[y] * h.data.stride + h.offset : d = a[y] * l;
        for (let g = 0; g < l; g++)
          u[m++] = o[d++];
      }
      return new yt(u, l, c);
    }
    if (this.index === null)
      return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const i = new ai(), e = this.index.array, s = this.attributes;
    for (const h in s) {
      const a = s[h], o = t(a, e);
      i.setAttribute(h, o);
    }
    const n = this.morphAttributes;
    for (const h in n) {
      const a = [], o = n[h];
      for (let l = 0, c = o.length; l < c; l++) {
        const u = o[l], d = t(u, e);
        a.push(d);
      }
      i.morphAttributes[h] = a;
    }
    i.morphTargetsRelative = this.morphTargetsRelative;
    const r = this.groups;
    for (let h = 0, a = r.length; h < a; h++) {
      const o = r[h];
      i.addGroup(o.start, o.count, o.materialIndex);
    }
    return i;
  }
  toJSON() {
    const t = {
      metadata: {
        version: 4.6,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), this.parameters !== void 0) {
      const a = this.parameters;
      for (const o in a)
        a[o] !== void 0 && (t[o] = a[o]);
      return t;
    }
    t.data = { attributes: {} };
    const i = this.index;
    i !== null && (t.data.index = {
      type: i.array.constructor.name,
      array: Array.prototype.slice.call(i.array)
    });
    const e = this.attributes;
    for (const a in e) {
      const o = e[a];
      t.data.attributes[a] = o.toJSON(t.data);
    }
    const s = {};
    let n = !1;
    for (const a in this.morphAttributes) {
      const o = this.morphAttributes[a], l = [];
      for (let c = 0, u = o.length; c < u; c++) {
        const d = o[c];
        l.push(d.toJSON(t.data));
      }
      l.length > 0 && (s[a] = l, n = !0);
    }
    n && (t.data.morphAttributes = s, t.data.morphTargetsRelative = this.morphTargetsRelative);
    const r = this.groups;
    r.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(r)));
    const h = this.boundingSphere;
    return h !== null && (t.data.boundingSphere = {
      center: h.center.toArray(),
      radius: h.radius
    }), t;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const i = {};
    this.name = t.name;
    const e = t.index;
    e !== null && this.setIndex(e.clone(i));
    const s = t.attributes;
    for (const o in s) {
      const l = s[o];
      this.setAttribute(o, l.clone(i));
    }
    const n = t.morphAttributes;
    for (const o in n) {
      const l = [], c = n[o];
      for (let u = 0, d = c.length; u < d; u++)
        l.push(c[u].clone(i));
      this.morphAttributes[o] = l;
    }
    this.morphTargetsRelative = t.morphTargetsRelative;
    const r = t.groups;
    for (let o = 0, l = r.length; o < l; o++) {
      const c = r[o];
      this.addGroup(c.start, c.count, c.materialIndex);
    }
    const h = t.boundingBox;
    h !== null && (this.boundingBox = h.clone());
    const a = t.boundingSphere;
    return a !== null && (this.boundingSphere = a.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const ye = /* @__PURE__ */ new O(), Bt = /* @__PURE__ */ new ss(), gi = /* @__PURE__ */ new $i(), xe = /* @__PURE__ */ new f(), Mi = /* @__PURE__ */ new f(), wi = /* @__PURE__ */ new f(), bi = /* @__PURE__ */ new f(), Gi = /* @__PURE__ */ new f(), Si = /* @__PURE__ */ new f(), ge = /* @__PURE__ */ new f(), _i = /* @__PURE__ */ new f();
class xs extends P {
  constructor(t = new ai(), i = new ps()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t, this.material = i, this.updateMorphTargets();
  }
  copy(t, i) {
    return super.copy(t, i), t.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), t.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = Array.isArray(t.material) ? t.material.slice() : t.material, this.geometry = t.geometry, this;
  }
  updateMorphTargets() {
    const i = this.geometry.morphAttributes, e = Object.keys(i);
    if (e.length > 0) {
      const s = i[e[0]];
      if (s !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let n = 0, r = s.length; n < r; n++) {
          const h = s[n].name || String(n);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[h] = n;
        }
      }
    }
  }
  getVertexPosition(t, i) {
    const e = this.geometry, s = e.attributes.position, n = e.morphAttributes.position, r = e.morphTargetsRelative;
    i.fromBufferAttribute(s, t);
    const h = this.morphTargetInfluences;
    if (n && h) {
      Si.set(0, 0, 0);
      for (let a = 0, o = n.length; a < o; a++) {
        const l = h[a], c = n[a];
        l !== 0 && (Gi.fromBufferAttribute(c, t), r ? Si.addScaledVector(Gi, l) : Si.addScaledVector(Gi.sub(i), l));
      }
      i.add(Si);
    }
    return i;
  }
  raycast(t, i) {
    const e = this.geometry, s = this.material, n = this.matrixWorld;
    s !== void 0 && (e.boundingSphere === null && e.computeBoundingSphere(), gi.copy(e.boundingSphere), gi.applyMatrix4(n), Bt.copy(t.ray).recast(t.near), !(gi.containsPoint(Bt.origin) === !1 && (Bt.intersectSphere(gi, xe) === null || Bt.origin.distanceToSquared(xe) > (t.far - t.near) ** 2)) && (ye.copy(n).invert(), Bt.copy(t.ray).applyMatrix4(ye), !(e.boundingBox !== null && Bt.intersectsBox(e.boundingBox) === !1) && this._computeIntersections(t, i, Bt)));
  }
  _computeIntersections(t, i, e) {
    let s;
    const n = this.geometry, r = this.material, h = n.index, a = n.attributes.position, o = n.attributes.uv, l = n.attributes.uv1, c = n.attributes.normal, u = n.groups, d = n.drawRange;
    if (h !== null)
      if (Array.isArray(r))
        for (let m = 0, y = u.length; m < y; m++) {
          const x = u[m], g = r[x.materialIndex], w = Math.max(x.start, d.start), b = Math.min(h.count, Math.min(x.start + x.count, d.start + d.count));
          for (let M = w, S = b; M < S; M += 3) {
            const F = h.getX(M), _ = h.getX(M + 1), A = h.getX(M + 2);
            s = zi(this, g, t, e, o, l, c, F, _, A), s && (s.faceIndex = Math.floor(M / 3), s.face.materialIndex = x.materialIndex, i.push(s));
          }
        }
      else {
        const m = Math.max(0, d.start), y = Math.min(h.count, d.start + d.count);
        for (let x = m, g = y; x < g; x += 3) {
          const w = h.getX(x), b = h.getX(x + 1), M = h.getX(x + 2);
          s = zi(this, r, t, e, o, l, c, w, b, M), s && (s.faceIndex = Math.floor(x / 3), i.push(s));
        }
      }
    else if (a !== void 0)
      if (Array.isArray(r))
        for (let m = 0, y = u.length; m < y; m++) {
          const x = u[m], g = r[x.materialIndex], w = Math.max(x.start, d.start), b = Math.min(a.count, Math.min(x.start + x.count, d.start + d.count));
          for (let M = w, S = b; M < S; M += 3) {
            const F = M, _ = M + 1, A = M + 2;
            s = zi(this, g, t, e, o, l, c, F, _, A), s && (s.faceIndex = Math.floor(M / 3), s.face.materialIndex = x.materialIndex, i.push(s));
          }
        }
      else {
        const m = Math.max(0, d.start), y = Math.min(a.count, d.start + d.count);
        for (let x = m, g = y; x < g; x += 3) {
          const w = x, b = x + 1, M = x + 2;
          s = zi(this, r, t, e, o, l, c, w, b, M), s && (s.faceIndex = Math.floor(x / 3), i.push(s));
        }
      }
  }
}
function gs(p, t, i, e, s, n, r, h) {
  let a;
  if (t.side === 1 ? a = e.intersectTriangle(r, n, s, !0, h) : a = e.intersectTriangle(s, n, r, t.side === 0, h), a === null) return null;
  _i.copy(h), _i.applyMatrix4(p.matrixWorld);
  const o = i.ray.origin.distanceTo(_i);
  return o < i.near || o > i.far ? null : {
    distance: o,
    point: _i.clone(),
    object: p
  };
}
function zi(p, t, i, e, s, n, r, h, a, o) {
  p.getVertexPosition(h, Mi), p.getVertexPosition(a, wi), p.getVertexPosition(o, bi);
  const l = gs(p, t, i, e, Mi, wi, bi, ge);
  if (l) {
    const c = new f();
    st.getBarycoord(ge, Mi, wi, bi, c), s && (l.uv = st.getInterpolatedAttribute(s, h, a, o, c, new C())), n && (l.uv1 = st.getInterpolatedAttribute(n, h, a, o, c, new C())), r && (l.normal = st.getInterpolatedAttribute(r, h, a, o, c, new f()), l.normal.dot(e.direction) > 0 && l.normal.multiplyScalar(-1));
    const u = {
      a: h,
      b: a,
      c: o,
      normal: new f(),
      materialIndex: 0
    };
    st.getNormal(Mi, wi, bi, u.normal), l.face = u, l.barycoord = c;
  }
  return l;
}
class Qi extends ai {
  constructor(t = 1, i = 1, e = 1, s = 1, n = 1, r = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: t,
      height: i,
      depth: e,
      widthSegments: s,
      heightSegments: n,
      depthSegments: r
    };
    const h = this;
    s = Math.floor(s), n = Math.floor(n), r = Math.floor(r);
    const a = [], o = [], l = [], c = [];
    let u = 0, d = 0;
    m("z", "y", "x", -1, -1, e, i, t, r, n, 0), m("z", "y", "x", 1, -1, e, i, -t, r, n, 1), m("x", "z", "y", 1, 1, t, e, i, s, r, 2), m("x", "z", "y", 1, -1, t, e, -i, s, r, 3), m("x", "y", "z", 1, -1, t, i, e, s, n, 4), m("x", "y", "z", -1, -1, t, i, -e, s, n, 5), this.setIndex(a), this.setAttribute("position", new Rt(o, 3)), this.setAttribute("normal", new Rt(l, 3)), this.setAttribute("uv", new Rt(c, 2));
    function m(y, x, g, w, b, M, S, F, _, A, R) {
      const E = M / _, k = S / A, nt = M / 2, I = S / 2, rt = F / 2, at = _ + 1, kt = A + 1;
      let Ft = 0, gt = 0;
      const L = new f();
      for (let N = 0; N < kt; N++) {
        const G = N * k - I;
        for (let It = 0; It < at; It++) {
          const hi = It * E - nt;
          L[y] = hi * w, L[x] = G * b, L[g] = rt, o.push(L.x, L.y, L.z), L[y] = 0, L[x] = 0, L[g] = F > 0 ? 1 : -1, l.push(L.x, L.y, L.z), c.push(It / _), c.push(1 - N / A), Ft += 1;
        }
      }
      for (let N = 0; N < A; N++)
        for (let G = 0; G < _; G++) {
          const It = u + G + at * N, hi = u + G + at * (N + 1), Ee = u + (G + 1) + at * (N + 1), te = u + (G + 1) + at * N;
          a.push(It, hi, te), a.push(hi, Ee, te), gt += 6;
        }
      h.addGroup(d, gt, R), d += gt, u += Ft;
    }
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  static fromJSON(t) {
    return new Qi(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
  }
}
function Ce(p) {
  const t = {};
  for (const i in p) {
    t[i] = {};
    for (const e in p[i]) {
      const s = p[i][e];
      s && (s.isColor || s.isMatrix3 || s.isMatrix4 || s.isVector2 || s.isVector3 || s.isVector4 || s.isTexture || s.isQuaternion) ? s.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), t[i][e] = null) : t[i][e] = s.clone() : Array.isArray(s) ? t[i][e] = s.slice() : t[i][e] = s;
    }
  }
  return t;
}
function Ms(p) {
  const t = [];
  for (let i = 0; i < p.length; i++)
    t.push(p[i].clone());
  return t;
}
var ws = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, bs = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class Ss extends $ {
  constructor(t) {
    super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = ws, this.fragmentShader = bs, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
      clipCullDistance: !1,
      // set to use vertex shader clipping
      multiDraw: !1
      // set to use vertex shader multi_draw / enable gl_DrawID
    }, this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv1: [0, 0]
    }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, t !== void 0 && this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = Ce(t.uniforms), this.uniformsGroups = Ms(t.uniformsGroups), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.fog = t.fog, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    i.glslVersion = this.glslVersion, i.uniforms = {};
    for (const s in this.uniforms) {
      const r = this.uniforms[s].value;
      r && r.isTexture ? i.uniforms[s] = {
        type: "t",
        value: r.toJSON(t).uuid
      } : r && r.isColor ? i.uniforms[s] = {
        type: "c",
        value: r.getHex()
      } : r && r.isVector2 ? i.uniforms[s] = {
        type: "v2",
        value: r.toArray()
      } : r && r.isVector3 ? i.uniforms[s] = {
        type: "v3",
        value: r.toArray()
      } : r && r.isVector4 ? i.uniforms[s] = {
        type: "v4",
        value: r.toArray()
      } : r && r.isMatrix3 ? i.uniforms[s] = {
        type: "m3",
        value: r.toArray()
      } : r && r.isMatrix4 ? i.uniforms[s] = {
        type: "m4",
        value: r.toArray()
      } : i.uniforms[s] = {
        value: r
      };
    }
    Object.keys(this.defines).length > 0 && (i.defines = this.defines), i.vertexShader = this.vertexShader, i.fragmentShader = this.fragmentShader, i.lights = this.lights, i.clipping = this.clipping;
    const e = {};
    for (const s in this.extensions)
      this.extensions[s] === !0 && (e[s] = !0);
    return Object.keys(e).length > 0 && (i.extensions = e), i;
  }
}
class Be extends P {
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new O(), this.projectionMatrix = new O(), this.projectionMatrixInverse = new O(), this.coordinateSystem = 2e3;
  }
  copy(t, i) {
    return super.copy(t, i), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this.coordinateSystem = t.coordinateSystem, this;
  }
  getWorldDirection(t) {
    return super.getWorldDirection(t).negate();
  }
  updateMatrixWorld(t) {
    super.updateMatrixWorld(t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(t, i) {
    super.updateWorldMatrix(t, i), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const zt = /* @__PURE__ */ new f(), Me = /* @__PURE__ */ new C(), we = /* @__PURE__ */ new C();
class At extends Be {
  constructor(t = 50, i = 1, e = 0.1, s = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t, this.zoom = 1, this.near = e, this.far = s, this.focus = 10, this.aspect = i, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(t, i) {
    return super.copy(t, i), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = t.view === null ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
  }
  /**
   * Sets the FOV by focal length in respect to the current .filmGauge.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(t) {
    const i = 0.5 * this.getFilmHeight() / t;
    this.fov = ei * 2 * Math.atan(i), this.updateProjectionMatrix();
  }
  /**
   * Calculates the focal length from the current .fov and .filmGauge.
   *
   * @returns {number}
   */
  getFocalLength() {
    const t = Math.tan(ti * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / t;
  }
  getEffectiveFOV() {
    return ei * 2 * Math.atan(
      Math.tan(ti * 0.5 * this.fov) / this.zoom
    );
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
   *
   * @param {number} distance
   * @param {Vector2} minTarget
   * @param {Vector2} maxTarget
   */
  getViewBounds(t, i, e) {
    zt.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse), i.set(zt.x, zt.y).multiplyScalar(-t / zt.z), zt.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse), e.set(zt.x, zt.y).multiplyScalar(-t / zt.z);
  }
  /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   *
   * @param {number} distance
   * @param {Vector2} target - Vector2 target used to store result where x is width and y is height.
   * @returns {Vector2}
   */
  getViewSize(t, i) {
    return this.getViewBounds(t, Me, we), i.subVectors(we, Me);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *
   * then for each monitor you would call it like this
   *
   *   const w = 1920;
   *   const h = 1080;
   *   const fullWidth = w * 3;
   *   const fullHeight = h * 2;
   *
   *   --A--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   *   --B--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   *   --C--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   *   --D--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   *   --E--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   *   --F--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   *
   *   Note there is no reason monitors have to be the same size or in a grid.
   *
   * @param {number} fullWidth
   * @param {number} fullHeight
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */
  setViewOffset(t, i, e, s, n, r) {
    this.aspect = t / i, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = i, this.view.offsetX = e, this.view.offsetY = s, this.view.width = n, this.view.height = r, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const t = this.near;
    let i = t * Math.tan(ti * 0.5 * this.fov) / this.zoom, e = 2 * i, s = this.aspect * e, n = -0.5 * s;
    const r = this.view;
    if (this.view !== null && this.view.enabled) {
      const a = r.fullWidth, o = r.fullHeight;
      n += r.offsetX * s / a, i -= r.offsetY * e / o, s *= r.width / a, e *= r.height / o;
    }
    const h = this.filmOffset;
    h !== 0 && (n += t * h / this.getFilmWidth()), this.projectionMatrix.makePerspective(n, n + s, i, i - e, t, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return i.object.fov = this.fov, i.object.zoom = this.zoom, i.object.near = this.near, i.object.far = this.far, i.object.focus = this.focus, i.object.aspect = this.aspect, this.view !== null && (i.object.view = Object.assign({}, this.view)), i.object.filmGauge = this.filmGauge, i.object.filmOffset = this.filmOffset, i;
  }
}
const Gt = -90, Xt = 1;
class _s extends P {
  constructor(t, i, e) {
    super(), this.type = "CubeCamera", this.renderTarget = e, this.coordinateSystem = null, this.activeMipmapLevel = 0;
    const s = new At(Gt, Xt, t, i);
    s.layers = this.layers, this.add(s);
    const n = new At(Gt, Xt, t, i);
    n.layers = this.layers, this.add(n);
    const r = new At(Gt, Xt, t, i);
    r.layers = this.layers, this.add(r);
    const h = new At(Gt, Xt, t, i);
    h.layers = this.layers, this.add(h);
    const a = new At(Gt, Xt, t, i);
    a.layers = this.layers, this.add(a);
    const o = new At(Gt, Xt, t, i);
    o.layers = this.layers, this.add(o);
  }
  updateCoordinateSystem() {
    const t = this.coordinateSystem, i = this.children.concat(), [e, s, n, r, h, a] = i;
    for (const o of i) this.remove(o);
    if (t === 2e3)
      e.up.set(0, 1, 0), e.lookAt(1, 0, 0), s.up.set(0, 1, 0), s.lookAt(-1, 0, 0), n.up.set(0, 0, -1), n.lookAt(0, 1, 0), r.up.set(0, 0, 1), r.lookAt(0, -1, 0), h.up.set(0, 1, 0), h.lookAt(0, 0, 1), a.up.set(0, 1, 0), a.lookAt(0, 0, -1);
    else if (t === 2001)
      e.up.set(0, -1, 0), e.lookAt(-1, 0, 0), s.up.set(0, -1, 0), s.lookAt(1, 0, 0), n.up.set(0, 0, 1), n.lookAt(0, 1, 0), r.up.set(0, 0, -1), r.lookAt(0, -1, 0), h.up.set(0, -1, 0), h.lookAt(0, 0, 1), a.up.set(0, -1, 0), a.lookAt(0, 0, -1);
    else
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + t);
    for (const o of i)
      this.add(o), o.updateMatrixWorld();
  }
  update(t, i) {
    this.parent === null && this.updateMatrixWorld();
    const { renderTarget: e, activeMipmapLevel: s } = this;
    this.coordinateSystem !== t.coordinateSystem && (this.coordinateSystem = t.coordinateSystem, this.updateCoordinateSystem());
    const [n, r, h, a, o, l] = this.children, c = t.getRenderTarget(), u = t.getActiveCubeFace(), d = t.getActiveMipmapLevel(), m = t.xr.enabled;
    t.xr.enabled = !1;
    const y = e.texture.generateMipmaps;
    e.texture.generateMipmaps = !1, t.setRenderTarget(e, 0, s), t.render(i, n), t.setRenderTarget(e, 1, s), t.render(i, r), t.setRenderTarget(e, 2, s), t.render(i, h), t.setRenderTarget(e, 3, s), t.render(i, a), t.setRenderTarget(e, 4, s), t.render(i, o), e.texture.generateMipmaps = y, t.setRenderTarget(e, 5, s), t.render(i, l), t.setRenderTarget(c, u, d), t.xr.enabled = m, e.texture.needsPMREMUpdate = !0;
  }
}
class zs extends Z {
  constructor(t, i, e, s, n, r, h, a, o, l) {
    t = t !== void 0 ? t : [], i = i !== void 0 ? i : 301, super(t, i, e, s, n, r, h, a, o, l), this.isCubeTexture = !0, this.flipY = !1;
  }
  get images() {
    return this.image;
  }
  set images(t) {
    this.image = t;
  }
}
class va extends is {
  constructor(t = 1, i = {}) {
    super(t, t, i), this.isWebGLCubeRenderTarget = !0;
    const e = { width: t, height: t, depth: 1 }, s = [e, e, e, e, e, e];
    this.texture = new zs(s, i.mapping, i.wrapS, i.wrapT, i.magFilter, i.minFilter, i.format, i.type, i.anisotropy, i.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = i.generateMipmaps !== void 0 ? i.generateMipmaps : !1, this.texture.minFilter = i.minFilter !== void 0 ? i.minFilter : 1006;
  }
  fromEquirectangularTexture(t, i) {
    this.texture.type = i.type, this.texture.colorSpace = i.colorSpace, this.texture.generateMipmaps = i.generateMipmaps, this.texture.minFilter = i.minFilter, this.texture.magFilter = i.magFilter;
    const e = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    }, s = new Qi(5, 5, 5), n = new Ss({
      name: "CubemapFromEquirect",
      uniforms: Ce(e.uniforms),
      vertexShader: e.vertexShader,
      fragmentShader: e.fragmentShader,
      side: 1,
      blending: 0
    });
    n.uniforms.tEquirect.value = i;
    const r = new xs(s, n), h = i.minFilter;
    return i.minFilter === 1008 && (i.minFilter = 1006), new _s(1, 10, this).update(t, r), i.minFilter = h, r.geometry.dispose(), r.material.dispose(), this;
  }
  clear(t, i, e, s) {
    const n = t.getRenderTarget();
    for (let r = 0; r < 6; r++)
      t.setRenderTarget(this, r), t.clear(i, e, s);
    t.setRenderTarget(n);
  }
}
class Ra extends P {
  constructor() {
    super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new ht(), this.environmentIntensity = 1, this.environmentRotation = new ht(), this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  copy(t, i) {
    return super.copy(t, i), t.background !== null && (this.background = t.background.clone()), t.environment !== null && (this.environment = t.environment.clone()), t.fog !== null && (this.fog = t.fog.clone()), this.backgroundBlurriness = t.backgroundBlurriness, this.backgroundIntensity = t.backgroundIntensity, this.backgroundRotation.copy(t.backgroundRotation), this.environmentIntensity = t.environmentIntensity, this.environmentRotation.copy(t.environmentRotation), t.overrideMaterial !== null && (this.overrideMaterial = t.overrideMaterial.clone()), this.matrixAutoUpdate = t.matrixAutoUpdate, this;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return this.fog !== null && (i.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (i.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (i.object.backgroundIntensity = this.backgroundIntensity), i.object.backgroundRotation = this.backgroundRotation.toArray(), this.environmentIntensity !== 1 && (i.object.environmentIntensity = this.environmentIntensity), i.object.environmentRotation = this.environmentRotation.toArray(), i;
  }
}
class As {
  constructor(t, i) {
    this.isInterleavedBuffer = !0, this.array = t, this.stride = i, this.count = t !== void 0 ? t.length / i : 0, this.usage = 35044, this.updateRanges = [], this.version = 0, this.uuid = mt();
  }
  onUploadCallback() {
  }
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  setUsage(t) {
    return this.usage = t, this;
  }
  addUpdateRange(t, i) {
    this.updateRanges.push({ start: t, count: i });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(t) {
    return this.array = new t.array.constructor(t.array), this.count = t.count, this.stride = t.stride, this.usage = t.usage, this;
  }
  copyAt(t, i, e) {
    t *= this.stride, e *= i.stride;
    for (let s = 0, n = this.stride; s < n; s++)
      this.array[t + s] = i.array[e + s];
    return this;
  }
  set(t, i = 0) {
    return this.array.set(t, i), this;
  }
  clone(t) {
    t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = mt()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
    const i = new this.array.constructor(t.arrayBuffers[this.array.buffer._uuid]), e = new this.constructor(i, this.stride);
    return e.setUsage(this.usage), e;
  }
  onUpload(t) {
    return this.onUploadCallback = t, this;
  }
  toJSON(t) {
    return t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = mt()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
const U = /* @__PURE__ */ new f();
class ve {
  constructor(t, i, e, s = !1) {
    this.isInterleavedBufferAttribute = !0, this.name = "", this.data = t, this.itemSize = i, this.offset = e, this.normalized = s;
  }
  get count() {
    return this.data.count;
  }
  get array() {
    return this.data.array;
  }
  set needsUpdate(t) {
    this.data.needsUpdate = t;
  }
  applyMatrix4(t) {
    for (let i = 0, e = this.data.count; i < e; i++)
      U.fromBufferAttribute(this, i), U.applyMatrix4(t), this.setXYZ(i, U.x, U.y, U.z);
    return this;
  }
  applyNormalMatrix(t) {
    for (let i = 0, e = this.count; i < e; i++)
      U.fromBufferAttribute(this, i), U.applyNormalMatrix(t), this.setXYZ(i, U.x, U.y, U.z);
    return this;
  }
  transformDirection(t) {
    for (let i = 0, e = this.count; i < e; i++)
      U.fromBufferAttribute(this, i), U.transformDirection(t), this.setXYZ(i, U.x, U.y, U.z);
    return this;
  }
  getComponent(t, i) {
    let e = this.array[t * this.data.stride + this.offset + i];
    return this.normalized && (e = q(e, this.array)), e;
  }
  setComponent(t, i, e) {
    return this.normalized && (e = z(e, this.array)), this.data.array[t * this.data.stride + this.offset + i] = e, this;
  }
  setX(t, i) {
    return this.normalized && (i = z(i, this.array)), this.data.array[t * this.data.stride + this.offset] = i, this;
  }
  setY(t, i) {
    return this.normalized && (i = z(i, this.array)), this.data.array[t * this.data.stride + this.offset + 1] = i, this;
  }
  setZ(t, i) {
    return this.normalized && (i = z(i, this.array)), this.data.array[t * this.data.stride + this.offset + 2] = i, this;
  }
  setW(t, i) {
    return this.normalized && (i = z(i, this.array)), this.data.array[t * this.data.stride + this.offset + 3] = i, this;
  }
  getX(t) {
    let i = this.data.array[t * this.data.stride + this.offset];
    return this.normalized && (i = q(i, this.array)), i;
  }
  getY(t) {
    let i = this.data.array[t * this.data.stride + this.offset + 1];
    return this.normalized && (i = q(i, this.array)), i;
  }
  getZ(t) {
    let i = this.data.array[t * this.data.stride + this.offset + 2];
    return this.normalized && (i = q(i, this.array)), i;
  }
  getW(t) {
    let i = this.data.array[t * this.data.stride + this.offset + 3];
    return this.normalized && (i = q(i, this.array)), i;
  }
  setXY(t, i, e) {
    return t = t * this.data.stride + this.offset, this.normalized && (i = z(i, this.array), e = z(e, this.array)), this.data.array[t + 0] = i, this.data.array[t + 1] = e, this;
  }
  setXYZ(t, i, e, s) {
    return t = t * this.data.stride + this.offset, this.normalized && (i = z(i, this.array), e = z(e, this.array), s = z(s, this.array)), this.data.array[t + 0] = i, this.data.array[t + 1] = e, this.data.array[t + 2] = s, this;
  }
  setXYZW(t, i, e, s, n) {
    return t = t * this.data.stride + this.offset, this.normalized && (i = z(i, this.array), e = z(e, this.array), s = z(s, this.array), n = z(n, this.array)), this.data.array[t + 0] = i, this.data.array[t + 1] = e, this.data.array[t + 2] = s, this.data.array[t + 3] = n, this;
  }
  clone(t) {
    if (t === void 0) {
      console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
      const i = [];
      for (let e = 0; e < this.count; e++) {
        const s = e * this.data.stride + this.offset;
        for (let n = 0; n < this.itemSize; n++)
          i.push(this.data.array[s + n]);
      }
      return new yt(new this.array.constructor(i), this.itemSize, this.normalized);
    } else
      return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new ve(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
  }
  toJSON(t) {
    if (t === void 0) {
      console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
      const i = [];
      for (let e = 0; e < this.count; e++) {
        const s = e * this.data.stride + this.offset;
        for (let n = 0; n < this.itemSize; n++)
          i.push(this.data.array[s + n]);
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: i,
        normalized: this.normalized
      };
    } else
      return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.toJSON(t)), {
        isInterleavedBufferAttribute: !0,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
  }
}
class Ea extends $ {
  constructor(t) {
    super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new B(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.rotation = t.rotation, this.sizeAttenuation = t.sizeAttenuation, this.fog = t.fog, this;
  }
}
class ka extends Z {
  constructor(t = null, i = 1, e = 1, s, n, r, h, a, o = 1003, l = 1003, c, u) {
    super(null, r, h, a, o, l, s, n, c, u), this.isDataTexture = !0, this.image = { data: t, width: i, height: e }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class Ia extends yt {
  constructor(t, i, e, s = 1) {
    super(t, i, e), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = s;
  }
  copy(t) {
    return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
  }
}
const Xi = /* @__PURE__ */ new f(), Fs = /* @__PURE__ */ new f(), Ts = /* @__PURE__ */ new xt();
class Ht {
  constructor(t = new f(1, 0, 0), i = 0) {
    this.isPlane = !0, this.normal = t, this.constant = i;
  }
  set(t, i) {
    return this.normal.copy(t), this.constant = i, this;
  }
  setComponents(t, i, e, s) {
    return this.normal.set(t, i, e), this.constant = s, this;
  }
  setFromNormalAndCoplanarPoint(t, i) {
    return this.normal.copy(t), this.constant = -i.dot(this.normal), this;
  }
  setFromCoplanarPoints(t, i, e) {
    const s = Xi.subVectors(e, i).cross(Fs.subVectors(t, i)).normalize();
    return this.setFromNormalAndCoplanarPoint(s, t), this;
  }
  copy(t) {
    return this.normal.copy(t.normal), this.constant = t.constant, this;
  }
  normalize() {
    const t = 1 / this.normal.length();
    return this.normal.multiplyScalar(t), this.constant *= t, this;
  }
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  distanceToPoint(t) {
    return this.normal.dot(t) + this.constant;
  }
  distanceToSphere(t) {
    return this.distanceToPoint(t.center) - t.radius;
  }
  projectPoint(t, i) {
    return i.copy(t).addScaledVector(this.normal, -this.distanceToPoint(t));
  }
  intersectLine(t, i) {
    const e = t.delta(Xi), s = this.normal.dot(e);
    if (s === 0)
      return this.distanceToPoint(t.start) === 0 ? i.copy(t.start) : null;
    const n = -(t.start.dot(this.normal) + this.constant) / s;
    return n < 0 || n > 1 ? null : i.copy(t.start).addScaledVector(e, n);
  }
  intersectsLine(t) {
    const i = this.distanceToPoint(t.start), e = this.distanceToPoint(t.end);
    return i < 0 && e > 0 || e < 0 && i > 0;
  }
  intersectsBox(t) {
    return t.intersectsPlane(this);
  }
  intersectsSphere(t) {
    return t.intersectsPlane(this);
  }
  coplanarPoint(t) {
    return t.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(t, i) {
    const e = i || Ts.getNormalMatrix(t), s = this.coplanarPoint(Xi).applyMatrix4(t), n = this.normal.applyMatrix3(e).normalize();
    return this.constant = -s.dot(n), this;
  }
  translate(t) {
    return this.constant -= t.dot(this.normal), this;
  }
  equals(t) {
    return t.normal.equals(this.normal) && t.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const vt = /* @__PURE__ */ new $i(), Ai = /* @__PURE__ */ new f();
class Cs {
  constructor(t = new Ht(), i = new Ht(), e = new Ht(), s = new Ht(), n = new Ht(), r = new Ht()) {
    this.planes = [t, i, e, s, n, r];
  }
  set(t, i, e, s, n, r) {
    const h = this.planes;
    return h[0].copy(t), h[1].copy(i), h[2].copy(e), h[3].copy(s), h[4].copy(n), h[5].copy(r), this;
  }
  copy(t) {
    const i = this.planes;
    for (let e = 0; e < 6; e++)
      i[e].copy(t.planes[e]);
    return this;
  }
  setFromProjectionMatrix(t, i = 2e3) {
    const e = this.planes, s = t.elements, n = s[0], r = s[1], h = s[2], a = s[3], o = s[4], l = s[5], c = s[6], u = s[7], d = s[8], m = s[9], y = s[10], x = s[11], g = s[12], w = s[13], b = s[14], M = s[15];
    if (e[0].setComponents(a - n, u - o, x - d, M - g).normalize(), e[1].setComponents(a + n, u + o, x + d, M + g).normalize(), e[2].setComponents(a + r, u + l, x + m, M + w).normalize(), e[3].setComponents(a - r, u - l, x - m, M - w).normalize(), e[4].setComponents(a - h, u - c, x - y, M - b).normalize(), i === 2e3)
      e[5].setComponents(a + h, u + c, x + y, M + b).normalize();
    else if (i === 2001)
      e[5].setComponents(h, c, y, b).normalize();
    else
      throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + i);
    return this;
  }
  intersectsObject(t) {
    if (t.boundingSphere !== void 0)
      t.boundingSphere === null && t.computeBoundingSphere(), vt.copy(t.boundingSphere).applyMatrix4(t.matrixWorld);
    else {
      const i = t.geometry;
      i.boundingSphere === null && i.computeBoundingSphere(), vt.copy(i.boundingSphere).applyMatrix4(t.matrixWorld);
    }
    return this.intersectsSphere(vt);
  }
  intersectsSprite(t) {
    return vt.center.set(0, 0, 0), vt.radius = 0.7071067811865476, vt.applyMatrix4(t.matrixWorld), this.intersectsSphere(vt);
  }
  intersectsSphere(t) {
    const i = this.planes, e = t.center, s = -t.radius;
    for (let n = 0; n < 6; n++)
      if (i[n].distanceToPoint(e) < s)
        return !1;
    return !0;
  }
  intersectsBox(t) {
    const i = this.planes;
    for (let e = 0; e < 6; e++) {
      const s = i[e];
      if (Ai.x = s.normal.x > 0 ? t.max.x : t.min.x, Ai.y = s.normal.y > 0 ? t.max.y : t.min.y, Ai.z = s.normal.z > 0 ? t.max.z : t.min.z, s.distanceToPoint(Ai) < 0)
        return !1;
    }
    return !0;
  }
  containsPoint(t) {
    const i = this.planes;
    for (let e = 0; e < 6; e++)
      if (i[e].distanceToPoint(t) < 0)
        return !1;
    return !0;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Bs extends $ {
  constructor(t) {
    super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new B(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this.fog = t.fog, this;
  }
}
class Da extends $ {
  constructor(t) {
    super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new B(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.size = t.size, this.sizeAttenuation = t.sizeAttenuation, this.fog = t.fog, this;
  }
}
class Pa extends Z {
  constructor(t, i) {
    super({ width: t, height: i }), this.isFramebufferTexture = !0, this.magFilter = 1003, this.minFilter = 1003, this.generateMipmaps = !1, this.needsUpdate = !0;
  }
}
class La extends Z {
  constructor(t, i, e, s, n, r, h, a, o, l = 1026) {
    if (l !== 1026 && l !== 1027)
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    e === void 0 && l === 1026 && (e = 1014), e === void 0 && l === 1027 && (e = 1020), super(null, s, n, r, h, a, l, e, o), this.isDepthTexture = !0, this.image = { width: t, height: i }, this.magFilter = h !== void 0 ? h : 1003, this.minFilter = a !== void 0 ? a : 1003, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
  }
  copy(t) {
    return super.copy(t), this.compareFunction = t.compareFunction, this;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return this.compareFunction !== null && (i.compareFunction = this.compareFunction), i;
  }
}
class Re extends ai {
  constructor(t = 1, i = 32, e = 16, s = 0, n = Math.PI * 2, r = 0, h = Math.PI) {
    super(), this.type = "SphereGeometry", this.parameters = {
      radius: t,
      widthSegments: i,
      heightSegments: e,
      phiStart: s,
      phiLength: n,
      thetaStart: r,
      thetaLength: h
    }, i = Math.max(3, Math.floor(i)), e = Math.max(2, Math.floor(e));
    const a = Math.min(r + h, Math.PI);
    let o = 0;
    const l = [], c = new f(), u = new f(), d = [], m = [], y = [], x = [];
    for (let g = 0; g <= e; g++) {
      const w = [], b = g / e;
      let M = 0;
      g === 0 && r === 0 ? M = 0.5 / i : g === e && a === Math.PI && (M = -0.5 / i);
      for (let S = 0; S <= i; S++) {
        const F = S / i;
        c.x = -t * Math.cos(s + F * n) * Math.sin(r + b * h), c.y = t * Math.cos(r + b * h), c.z = t * Math.sin(s + F * n) * Math.sin(r + b * h), m.push(c.x, c.y, c.z), u.copy(c).normalize(), y.push(u.x, u.y, u.z), x.push(F + M, 1 - b), w.push(o++);
      }
      l.push(w);
    }
    for (let g = 0; g < e; g++)
      for (let w = 0; w < i; w++) {
        const b = l[g][w + 1], M = l[g][w], S = l[g + 1][w], F = l[g + 1][w + 1];
        (g !== 0 || r > 0) && d.push(b, M, F), (g !== e - 1 || a < Math.PI) && d.push(M, S, F);
      }
    this.setIndex(d), this.setAttribute("position", new Rt(m, 3)), this.setAttribute("normal", new Rt(y, 3)), this.setAttribute("uv", new Rt(x, 2));
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  static fromJSON(t) {
    return new Re(t.radius, t.widthSegments, t.heightSegments, t.phiStart, t.phiLength, t.thetaStart, t.thetaLength);
  }
}
class Oa extends $ {
  constructor(t) {
    super(), this.isShadowMaterial = !0, this.type = "ShadowMaterial", this.color = new B(0), this.transparent = !0, this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.fog = t.fog, this;
  }
}
class vs extends $ {
  constructor(t) {
    super(), this.isMeshStandardMaterial = !0, this.type = "MeshStandardMaterial", this.defines = { STANDARD: "" }, this.color = new B(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new B(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new C(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new ht(), this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.defines = { STANDARD: "" }, this.color.copy(t.color), this.roughness = t.roughness, this.metalness = t.metalness, this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.roughnessMap = t.roughnessMap, this.metalnessMap = t.metalnessMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.envMapIntensity = t.envMapIntensity, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this.fog = t.fog, this;
  }
}
class Na extends vs {
  constructor(t) {
    super(), this.isMeshPhysicalMaterial = !0, this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new C(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
      get: function() {
        return T(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function(i) {
        this.ior = (1 + 0.4 * i) / (1 - 0.4 * i);
      }
    }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [100, 400], this.iridescenceThicknessMap = null, this.sheenColor = new B(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new B(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new B(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._dispersion = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(t);
  }
  get anisotropy() {
    return this._anisotropy;
  }
  set anisotropy(t) {
    this._anisotropy > 0 != t > 0 && this.version++, this._anisotropy = t;
  }
  get clearcoat() {
    return this._clearcoat;
  }
  set clearcoat(t) {
    this._clearcoat > 0 != t > 0 && this.version++, this._clearcoat = t;
  }
  get iridescence() {
    return this._iridescence;
  }
  set iridescence(t) {
    this._iridescence > 0 != t > 0 && this.version++, this._iridescence = t;
  }
  get dispersion() {
    return this._dispersion;
  }
  set dispersion(t) {
    this._dispersion > 0 != t > 0 && this.version++, this._dispersion = t;
  }
  get sheen() {
    return this._sheen;
  }
  set sheen(t) {
    this._sheen > 0 != t > 0 && this.version++, this._sheen = t;
  }
  get transmission() {
    return this._transmission;
  }
  set transmission(t) {
    this._transmission > 0 != t > 0 && this.version++, this._transmission = t;
  }
  copy(t) {
    return super.copy(t), this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.anisotropy = t.anisotropy, this.anisotropyRotation = t.anisotropyRotation, this.anisotropyMap = t.anisotropyMap, this.clearcoat = t.clearcoat, this.clearcoatMap = t.clearcoatMap, this.clearcoatRoughness = t.clearcoatRoughness, this.clearcoatRoughnessMap = t.clearcoatRoughnessMap, this.clearcoatNormalMap = t.clearcoatNormalMap, this.clearcoatNormalScale.copy(t.clearcoatNormalScale), this.dispersion = t.dispersion, this.ior = t.ior, this.iridescence = t.iridescence, this.iridescenceMap = t.iridescenceMap, this.iridescenceIOR = t.iridescenceIOR, this.iridescenceThicknessRange = [...t.iridescenceThicknessRange], this.iridescenceThicknessMap = t.iridescenceThicknessMap, this.sheen = t.sheen, this.sheenColor.copy(t.sheenColor), this.sheenColorMap = t.sheenColorMap, this.sheenRoughness = t.sheenRoughness, this.sheenRoughnessMap = t.sheenRoughnessMap, this.transmission = t.transmission, this.transmissionMap = t.transmissionMap, this.thickness = t.thickness, this.thicknessMap = t.thicknessMap, this.attenuationDistance = t.attenuationDistance, this.attenuationColor.copy(t.attenuationColor), this.specularIntensity = t.specularIntensity, this.specularIntensityMap = t.specularIntensityMap, this.specularColor.copy(t.specularColor), this.specularColorMap = t.specularColorMap, this;
  }
}
class Va extends $ {
  constructor(t) {
    super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new B(16777215), this.specular = new B(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new B(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new C(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new ht(), this.combine = 0, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.specular.copy(t.specular), this.shininess = t.shininess, this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this.fog = t.fog, this;
  }
}
class Wa extends $ {
  constructor(t) {
    super(), this.isMeshToonMaterial = !0, this.defines = { TOON: "" }, this.type = "MeshToonMaterial", this.color = new B(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new B(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new C(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.gradientMap = t.gradientMap, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.alphaMap = t.alphaMap, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
  }
}
class Ua extends $ {
  constructor(t) {
    super(), this.isMeshNormalMaterial = !0, this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new C(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.flatShading = t.flatShading, this;
  }
}
class qa extends $ {
  constructor(t) {
    super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new B(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new B(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new C(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new ht(), this.combine = 0, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this.fog = t.fog, this;
  }
}
class ja extends $ {
  constructor(t) {
    super(), this.isMeshMatcapMaterial = !0, this.defines = { MATCAP: "" }, this.type = "MeshMatcapMaterial", this.color = new B(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new C(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.flatShading = !1, this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.defines = { MATCAP: "" }, this.color.copy(t.color), this.matcap = t.matcap, this.map = t.map, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.alphaMap = t.alphaMap, this.flatShading = t.flatShading, this.fog = t.fog, this;
  }
}
class Ga extends Bs {
  constructor(t) {
    super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.scale = t.scale, this.dashSize = t.dashSize, this.gapSize = t.gapSize, this;
  }
}
class Et extends P {
  constructor(t, i = 1) {
    super(), this.isLight = !0, this.type = "Light", this.color = new B(t), this.intensity = i;
  }
  dispose() {
  }
  copy(t, i) {
    return super.copy(t, i), this.color.copy(t.color), this.intensity = t.intensity, this;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return i.object.color = this.color.getHex(), i.object.intensity = this.intensity, this.groundColor !== void 0 && (i.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (i.object.distance = this.distance), this.angle !== void 0 && (i.object.angle = this.angle), this.decay !== void 0 && (i.object.decay = this.decay), this.penumbra !== void 0 && (i.object.penumbra = this.penumbra), this.shadow !== void 0 && (i.object.shadow = this.shadow.toJSON()), this.target !== void 0 && (i.object.target = this.target.uuid), i;
  }
}
class Xa extends Et {
  constructor(t, i, e) {
    super(t, e), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(P.DEFAULT_UP), this.updateMatrix(), this.groundColor = new B(i);
  }
  copy(t, i) {
    return super.copy(t, i), this.groundColor.copy(t.groundColor), this;
  }
}
const Hi = /* @__PURE__ */ new O(), be = /* @__PURE__ */ new f(), Se = /* @__PURE__ */ new f();
class Ki {
  constructor(t) {
    this.camera = t, this.intensity = 1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new C(512, 512), this.map = null, this.mapPass = null, this.matrix = new O(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new Cs(), this._frameExtents = new C(1, 1), this._viewportCount = 1, this._viewports = [
      new j(0, 0, 1, 1)
    ];
  }
  getViewportCount() {
    return this._viewportCount;
  }
  getFrustum() {
    return this._frustum;
  }
  updateMatrices(t) {
    const i = this.camera, e = this.matrix;
    be.setFromMatrixPosition(t.matrixWorld), i.position.copy(be), Se.setFromMatrixPosition(t.target.matrixWorld), i.lookAt(Se), i.updateMatrixWorld(), Hi.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), this._frustum.setFromProjectionMatrix(Hi), e.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    ), e.multiply(Hi);
  }
  getViewport(t) {
    return this._viewports[t];
  }
  getFrameExtents() {
    return this._frameExtents;
  }
  dispose() {
    this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
  }
  copy(t) {
    return this.camera = t.camera.clone(), this.intensity = t.intensity, this.bias = t.bias, this.radius = t.radius, this.mapSize.copy(t.mapSize), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const t = {};
    return this.intensity !== 1 && (t.intensity = this.intensity), this.bias !== 0 && (t.bias = this.bias), this.normalBias !== 0 && (t.normalBias = this.normalBias), this.radius !== 1 && (t.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
  }
}
class Rs extends Ki {
  constructor() {
    super(new At(50, 1, 0.5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
  }
  updateMatrices(t) {
    const i = this.camera, e = ei * 2 * t.angle * this.focus, s = this.mapSize.width / this.mapSize.height, n = t.distance || i.far;
    (e !== i.fov || s !== i.aspect || n !== i.far) && (i.fov = e, i.aspect = s, i.far = n, i.updateProjectionMatrix()), super.updateMatrices(t);
  }
  copy(t) {
    return super.copy(t), this.focus = t.focus, this;
  }
}
class Ha extends Et {
  constructor(t, i, e = 0, s = Math.PI / 3, n = 0, r = 2) {
    super(t, i), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(P.DEFAULT_UP), this.updateMatrix(), this.target = new P(), this.distance = e, this.angle = s, this.penumbra = n, this.decay = r, this.map = null, this.shadow = new Rs();
  }
  get power() {
    return this.intensity * Math.PI;
  }
  set power(t) {
    this.intensity = t / Math.PI;
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(t, i) {
    return super.copy(t, i), this.distance = t.distance, this.angle = t.angle, this.penumbra = t.penumbra, this.decay = t.decay, this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
  }
}
const _e = /* @__PURE__ */ new O(), Kt = /* @__PURE__ */ new f(), Yi = /* @__PURE__ */ new f();
class Es extends Ki {
  constructor() {
    super(new At(90, 1, 0.5, 500)), this.isPointLightShadow = !0, this._frameExtents = new C(4, 2), this._viewportCount = 6, this._viewports = [
      // These viewports map a cube-map onto a 2D texture with the
      // following orientation:
      //
      //  xzXZ
      //   y Y
      //
      // X - Positive x direction
      // x - Negative x direction
      // Y - Positive y direction
      // y - Negative y direction
      // Z - Positive z direction
      // z - Negative z direction
      // positive X
      new j(2, 1, 1, 1),
      // negative X
      new j(0, 1, 1, 1),
      // positive Z
      new j(3, 1, 1, 1),
      // negative Z
      new j(1, 1, 1, 1),
      // positive Y
      new j(3, 0, 1, 1),
      // negative Y
      new j(1, 0, 1, 1)
    ], this._cubeDirections = [
      new f(1, 0, 0),
      new f(-1, 0, 0),
      new f(0, 0, 1),
      new f(0, 0, -1),
      new f(0, 1, 0),
      new f(0, -1, 0)
    ], this._cubeUps = [
      new f(0, 1, 0),
      new f(0, 1, 0),
      new f(0, 1, 0),
      new f(0, 1, 0),
      new f(0, 0, 1),
      new f(0, 0, -1)
    ];
  }
  updateMatrices(t, i = 0) {
    const e = this.camera, s = this.matrix, n = t.distance || e.far;
    n !== e.far && (e.far = n, e.updateProjectionMatrix()), Kt.setFromMatrixPosition(t.matrixWorld), e.position.copy(Kt), Yi.copy(e.position), Yi.add(this._cubeDirections[i]), e.up.copy(this._cubeUps[i]), e.lookAt(Yi), e.updateMatrixWorld(), s.makeTranslation(-Kt.x, -Kt.y, -Kt.z), _e.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(_e);
  }
}
class Ya extends Et {
  constructor(t, i, e = 0, s = 2) {
    super(t, i), this.isPointLight = !0, this.type = "PointLight", this.distance = e, this.decay = s, this.shadow = new Es();
  }
  get power() {
    return this.intensity * 4 * Math.PI;
  }
  set power(t) {
    this.intensity = t / (4 * Math.PI);
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(t, i) {
    return super.copy(t, i), this.distance = t.distance, this.decay = t.decay, this.shadow = t.shadow.clone(), this;
  }
}
class ks extends Be {
  constructor(t = -1, i = 1, e = 1, s = -1, n = 0.1, r = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t, this.right = i, this.top = e, this.bottom = s, this.near = n, this.far = r, this.updateProjectionMatrix();
  }
  copy(t, i) {
    return super.copy(t, i), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = t.view === null ? null : Object.assign({}, t.view), this;
  }
  setViewOffset(t, i, e, s, n, r) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = i, this.view.offsetX = e, this.view.offsetY = s, this.view.width = n, this.view.height = r, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const t = (this.right - this.left) / (2 * this.zoom), i = (this.top - this.bottom) / (2 * this.zoom), e = (this.right + this.left) / 2, s = (this.top + this.bottom) / 2;
    let n = e - t, r = e + t, h = s + i, a = s - i;
    if (this.view !== null && this.view.enabled) {
      const o = (this.right - this.left) / this.view.fullWidth / this.zoom, l = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      n += o * this.view.offsetX, r = n + o * this.view.width, h -= l * this.view.offsetY, a = h - l * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(n, r, h, a, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return i.object.zoom = this.zoom, i.object.left = this.left, i.object.right = this.right, i.object.top = this.top, i.object.bottom = this.bottom, i.object.near = this.near, i.object.far = this.far, this.view !== null && (i.object.view = Object.assign({}, this.view)), i;
  }
}
class Is extends Ki {
  constructor() {
    super(new ks(-5, 5, 5, -5, 0.5, 500)), this.isDirectionalLightShadow = !0;
  }
}
class Za extends Et {
  constructor(t, i) {
    super(t, i), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(P.DEFAULT_UP), this.updateMatrix(), this.target = new P(), this.shadow = new Is();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(t) {
    return super.copy(t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
  }
}
class Ja extends Et {
  constructor(t, i) {
    super(t, i), this.isAmbientLight = !0, this.type = "AmbientLight";
  }
}
class $a extends Et {
  constructor(t, i, e = 10, s = 10) {
    super(t, i), this.isRectAreaLight = !0, this.type = "RectAreaLight", this.width = e, this.height = s;
  }
  get power() {
    return this.intensity * this.width * this.height * Math.PI;
  }
  set power(t) {
    this.intensity = t / (this.width * this.height * Math.PI);
  }
  copy(t) {
    return super.copy(t), this.width = t.width, this.height = t.height, this;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return i.object.width = this.width, i.object.height = this.height, i;
  }
}
class Ds {
  constructor() {
    this.isSphericalHarmonics3 = !0, this.coefficients = [];
    for (let t = 0; t < 9; t++)
      this.coefficients.push(new f());
  }
  set(t) {
    for (let i = 0; i < 9; i++)
      this.coefficients[i].copy(t[i]);
    return this;
  }
  zero() {
    for (let t = 0; t < 9; t++)
      this.coefficients[t].set(0, 0, 0);
    return this;
  }
  // get the radiance in the direction of the normal
  // target is a Vector3
  getAt(t, i) {
    const e = t.x, s = t.y, n = t.z, r = this.coefficients;
    return i.copy(r[0]).multiplyScalar(0.282095), i.addScaledVector(r[1], 0.488603 * s), i.addScaledVector(r[2], 0.488603 * n), i.addScaledVector(r[3], 0.488603 * e), i.addScaledVector(r[4], 1.092548 * (e * s)), i.addScaledVector(r[5], 1.092548 * (s * n)), i.addScaledVector(r[6], 0.315392 * (3 * n * n - 1)), i.addScaledVector(r[7], 1.092548 * (e * n)), i.addScaledVector(r[8], 0.546274 * (e * e - s * s)), i;
  }
  // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
  // target is a Vector3
  // https://graphics.stanford.edu/papers/envmap/envmap.pdf
  getIrradianceAt(t, i) {
    const e = t.x, s = t.y, n = t.z, r = this.coefficients;
    return i.copy(r[0]).multiplyScalar(0.886227), i.addScaledVector(r[1], 2 * 0.511664 * s), i.addScaledVector(r[2], 2 * 0.511664 * n), i.addScaledVector(r[3], 2 * 0.511664 * e), i.addScaledVector(r[4], 2 * 0.429043 * e * s), i.addScaledVector(r[5], 2 * 0.429043 * s * n), i.addScaledVector(r[6], 0.743125 * n * n - 0.247708), i.addScaledVector(r[7], 2 * 0.429043 * e * n), i.addScaledVector(r[8], 0.429043 * (e * e - s * s)), i;
  }
  add(t) {
    for (let i = 0; i < 9; i++)
      this.coefficients[i].add(t.coefficients[i]);
    return this;
  }
  addScaledSH(t, i) {
    for (let e = 0; e < 9; e++)
      this.coefficients[e].addScaledVector(t.coefficients[e], i);
    return this;
  }
  scale(t) {
    for (let i = 0; i < 9; i++)
      this.coefficients[i].multiplyScalar(t);
    return this;
  }
  lerp(t, i) {
    for (let e = 0; e < 9; e++)
      this.coefficients[e].lerp(t.coefficients[e], i);
    return this;
  }
  equals(t) {
    for (let i = 0; i < 9; i++)
      if (!this.coefficients[i].equals(t.coefficients[i]))
        return !1;
    return !0;
  }
  copy(t) {
    return this.set(t.coefficients);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  fromArray(t, i = 0) {
    const e = this.coefficients;
    for (let s = 0; s < 9; s++)
      e[s].fromArray(t, i + s * 3);
    return this;
  }
  toArray(t = [], i = 0) {
    const e = this.coefficients;
    for (let s = 0; s < 9; s++)
      e[s].toArray(t, i + s * 3);
    return t;
  }
  // evaluate the basis functions
  // shBasis is an Array[ 9 ]
  static getBasisAt(t, i) {
    const e = t.x, s = t.y, n = t.z;
    i[0] = 0.282095, i[1] = 0.488603 * s, i[2] = 0.488603 * n, i[3] = 0.488603 * e, i[4] = 1.092548 * e * s, i[5] = 1.092548 * s * n, i[6] = 0.315392 * (3 * n * n - 1), i[7] = 1.092548 * e * n, i[8] = 0.546274 * (e * e - s * s);
  }
}
class Qa extends Et {
  constructor(t = new Ds(), i = 1) {
    super(void 0, i), this.isLightProbe = !0, this.sh = t;
  }
  copy(t) {
    return super.copy(t), this.sh.copy(t.sh), this;
  }
  fromJSON(t) {
    return this.intensity = t.intensity, this.sh.fromArray(t.sh), this;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return i.object.sh = this.sh.toArray(), i;
  }
}
class Ka extends As {
  constructor(t, i, e = 1) {
    super(t, i), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = e;
  }
  copy(t) {
    return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
  }
  clone(t) {
    const i = super.clone(t);
    return i.meshPerAttribute = this.meshPerAttribute, i;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return i.isInstancedInterleavedBuffer = !0, i.meshPerAttribute = this.meshPerAttribute, i;
  }
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: ze
} }));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = ze);
export {
  Bn as ACESFilmicToneMapping,
  $s as AddEquation,
  zn as AddOperation,
  Hs as AdditiveBlending,
  vn as AgXToneMapping,
  ar as AlphaFormat,
  wa as AlwaysCompare,
  fn as AlwaysDepth,
  pa as AlwaysStencilFunc,
  Ja as AmbientLight,
  qs as BackSide,
  Ns as BasicShadowMap,
  ri as Box3,
  Qi as BoxGeometry,
  yt as BufferAttribute,
  ai as BufferGeometry,
  Zn as ByteType,
  Be as Camera,
  Cn as CineonToneMapping,
  Nn as ClampToEdgeWrapping,
  B as Color,
  Q as ColorManagement,
  _s as CubeCamera,
  kn as CubeReflectionMapping,
  In as CubeRefractionMapping,
  zs as CubeTexture,
  Ln as CubeUVReflectionMapping,
  Ls as CullFaceBack,
  Os as CullFaceFront,
  Ps as CullFaceNone,
  Js as CustomBlending,
  Ca as DataArrayTexture,
  ka as DataTexture,
  ia as DecrementStencilOp,
  sa as DecrementWrapStencilOp,
  ur as DepthFormat,
  pr as DepthStencilFormat,
  La as DepthTexture,
  Za as DirectionalLight,
  js as DoubleSide,
  ln as DstAlphaFactor,
  un as DstColorFactor,
  Sa as DynamicDrawUsage,
  fa as EqualCompare,
  gn as EqualDepth,
  ha as EqualStencilFunc,
  Dn as EquirectangularReflectionMapping,
  Pn as EquirectangularRefractionMapping,
  ht as Euler,
  si as EventDispatcher,
  Ba as Float16BufferAttribute,
  Rt as Float32BufferAttribute,
  tr as FloatType,
  Pa as FramebufferTexture,
  Us as FrontSide,
  Cs as Frustum,
  xa as GreaterCompare,
  wn as GreaterDepth,
  Ma as GreaterEqualCompare,
  Mn as GreaterEqualDepth,
  ua as GreaterEqualStencilFunc,
  la as GreaterStencilFunc,
  ir as HalfFloatType,
  Xa as HemisphereLight,
  $e as ImageUtils,
  ta as IncrementStencilOp,
  ea as IncrementWrapStencilOp,
  Ia as InstancedBufferAttribute,
  Ka as InstancedInterleavedBuffer,
  Qn as IntType,
  As as InterleavedBuffer,
  ve as InterleavedBufferAttribute,
  na as InvertStencilOp,
  Qr as KeepStencilOp,
  as as Layers,
  ma as LessCompare,
  yn as LessDepth,
  ya as LessEqualCompare,
  xn as LessEqualDepth,
  oa as LessEqualStencilFunc,
  aa as LessStencilFunc,
  Et as Light,
  Qa as LightProbe,
  Bs as LineBasicMaterial,
  Ga as LineDashedMaterial,
  jn as LinearFilter,
  Hn as LinearMipMapLinearFilter,
  Xn as LinearMipmapLinearFilter,
  Gn as LinearMipmapNearestFilter,
  ie as LinearSRGBColorSpace,
  Fn as LinearToneMapping,
  ee as LinearTransfer,
  cr as LuminanceAlphaFormat,
  lr as LuminanceFormat,
  $ as Material,
  Aa as MathUtils,
  xt as Matrix3,
  O as Matrix4,
  en as MaxEquation,
  xs as Mesh,
  ps as MeshBasicMaterial,
  qa as MeshLambertMaterial,
  ja as MeshMatcapMaterial,
  Ua as MeshNormalMaterial,
  Va as MeshPhongMaterial,
  Na as MeshPhysicalMaterial,
  vs as MeshStandardMaterial,
  Wa as MeshToonMaterial,
  tn as MinEquation,
  Vn as MirroredRepeatWrapping,
  _n as MixOperation,
  Zs as MultiplyBlending,
  Sn as MultiplyOperation,
  Wn as NearestFilter,
  qn as NearestMipmapLinearFilter,
  Un as NearestMipmapNearestFilter,
  Rn as NeutralToneMapping,
  da as NeverCompare,
  mn as NeverDepth,
  ra as NeverStencilFunc,
  Gs as NoBlending,
  Ae as NoColorSpace,
  An as NoToneMapping,
  Xs as NormalBlending,
  ga as NotEqualCompare,
  bn as NotEqualDepth,
  ca as NotEqualStencilFunc,
  P as Object3D,
  Jr as ObjectSpaceNormalMap,
  nn as OneFactor,
  cn as OneMinusDstAlphaFactor,
  pn as OneMinusDstColorFactor,
  on as OneMinusSrcAlphaFactor,
  an as OneMinusSrcColorFactor,
  ks as OrthographicCamera,
  Vs as PCFShadowMap,
  At as PerspectiveCamera,
  Ht as Plane,
  Ya as PointLight,
  Da as PointsMaterial,
  ni as Quaternion,
  ei as RAD2DEG,
  Hr as RED_GREEN_RGTC2_Format,
  Gr as RED_RGTC1_Format,
  ze as REVISION,
  or as RGBAFormat,
  gr as RGBAIntegerFormat,
  Wr as RGBA_ASTC_10x10_Format,
  Or as RGBA_ASTC_10x5_Format,
  Nr as RGBA_ASTC_10x6_Format,
  Vr as RGBA_ASTC_10x8_Format,
  Ur as RGBA_ASTC_12x10_Format,
  qr as RGBA_ASTC_12x12_Format,
  vr as RGBA_ASTC_4x4_Format,
  Rr as RGBA_ASTC_5x4_Format,
  Er as RGBA_ASTC_5x5_Format,
  kr as RGBA_ASTC_6x5_Format,
  Ir as RGBA_ASTC_6x6_Format,
  Dr as RGBA_ASTC_8x5_Format,
  Pr as RGBA_ASTC_8x6_Format,
  Lr as RGBA_ASTC_8x8_Format,
  jr as RGBA_BPTC_Format,
  Br as RGBA_ETC2_EAC_Format,
  Fr as RGBA_PVRTC_2BPPV1_Format,
  Ar as RGBA_PVRTC_4BPPV1_Format,
  wr as RGBA_S3TC_DXT1_Format,
  br as RGBA_S3TC_DXT3_Format,
  Sr as RGBA_S3TC_DXT5_Format,
  hr as RGBFormat,
  xr as RGBIntegerFormat,
  Tr as RGB_ETC1_Format,
  Cr as RGB_ETC2_Format,
  zr as RGB_PVRTC_2BPPV1_Format,
  _r as RGB_PVRTC_4BPPV1_Format,
  Mr as RGB_S3TC_DXT1_Format,
  fr as RGFormat,
  yr as RGIntegerFormat,
  ss as Ray,
  $a as RectAreaLight,
  dr as RedFormat,
  mr as RedIntegerFormat,
  Tn as ReinhardToneMapping,
  ts as RenderTarget,
  On as RepeatWrapping,
  Kr as ReplaceStencilOp,
  Ks as ReverseSubtractEquation,
  Yr as SIGNED_RED_GREEN_RGTC2_Format,
  Xr as SIGNED_RED_RGTC1_Format,
  et as SRGBColorSpace,
  Fi as SRGBTransfer,
  Ra as Scene,
  Ss as ShaderMaterial,
  Oa as ShadowMaterial,
  Jn as ShortType,
  Fe as Source,
  $i as Sphere,
  Re as SphereGeometry,
  Ds as SphericalHarmonics3,
  Ha as SpotLight,
  Ea as SpriteMaterial,
  hn as SrcAlphaFactor,
  dn as SrcAlphaSaturateFactor,
  rn as SrcColorFactor,
  ba as StaticDrawUsage,
  Qs as SubtractEquation,
  Ys as SubtractiveBlending,
  Zr as TangentSpaceNormalMap,
  Z as Texture,
  st as Triangle,
  En as UVMapping,
  ms as Uint16BufferAttribute,
  fs as Uint32BufferAttribute,
  Yn as UnsignedByteType,
  nr as UnsignedInt248Type,
  rr as UnsignedInt5999Type,
  Kn as UnsignedIntType,
  er as UnsignedShort4444Type,
  sr as UnsignedShort5551Type,
  $n as UnsignedShortType,
  Ws as VSMShadowMap,
  C as Vector2,
  f as Vector3,
  j as Vector4,
  _a as WebGLCoordinateSystem,
  va as WebGLCubeRenderTarget,
  is as WebGLRenderTarget,
  za as WebGPUCoordinateSystem,
  sn as ZeroFactor,
  $r as ZeroStencilOp,
  Ze as arrayNeedsUint32,
  Ce as cloneUniforms,
  Fa as createCanvasElement,
  Zi as createElementNS,
  Ta as warnOnce
};
